import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import {
  faCirclePlus,
  faDatabase,
  faDownload,
  faEdit,
  faEye,
  faMagnifyingGlass,
  faRetweet,
  faSearch,
  // faTrashCan,
  faUpload,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import ReactApexChart from "react-apexcharts";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { GenerateRandomCode } from "../../APIs/GenerateRandomCode.api";
import { Tables } from "../../APIs/Tables.api";
import { BarCodeActivation } from "../../Components/BarcodeActivation";
import { BarcodeSuggestion } from "../../Components/BarcodeSuggestion";
import { StatisticChart } from "../../Components/Charts/Statistic/statistic.chart";
import { TableChart } from "../../Components/Charts/Table";
import { SearchComponent } from "../../Components/Search";
import { DelayLoading } from "../../Hooks/DelayLoading";
import { Calculation } from "../../utils/Calculation";
import { IsDate } from "../../utils/isDate";
import { IsNumber } from "../../utils/isNumber";

import icons from "./icon";

import moment from "moment/moment";
import { Option } from "../../Components/Option/Search";
import { SearchingDataContext } from "../../Context/SearchingDataContext";
import FilterData from "../common/filterData";
import { Conditions } from "../../utils/Conditions";
import { Accordion } from "../../Components/Accordion";
import AccordionTable from "../common/AccordionTable";
import PhieuXuatKho from "../../Components/pdf/components/PhieuXuatKho";
import PhieuNhapKhoPDF from "../../Components/pdf/components/PhieuNhapKho";
import LenhGiaoHang from "../../Components/pdf/components/LenhGiaoHang";
import PopupImagesList from "../../pages/LenhSanXuat/components/popupImagesList";
import PhieuNhapKhoKCS from "../../pages/PhieuNhapKho/components/PhieuNhapKhoKCS";
import { UpdatePhieuNhapKho } from "../../pages/PhieuNhapKho";
import UpdatePhieuXuatKho from "../../pages/PXK/components/UpdatePhieuXuatKho";
import ModalSoanHangPhieuXuatKho from "../../pages/PXK/components/ModalSoanHangPhieuXuatKho";

// import RenderDetail from "../page/redirect";
// import LoadingIcon from '../../Icons/loading.icon'

const IS_DISABLED_BUTTON = true;

const CHART_TYPE = {
  VerticalLineChartSingleData: "bar",
  VerticalLineChartManyData: "bar",
  HorizontalLineChart: "bar",
  CircleChart: "pie",
};

const RenderComponent = ({
  page,
  component,
  apiData,
  redirectToInput,
  redirectToInputPUT,
  handleDelete,
  handleSearchClick,
  exportToCSV,
  handleViewDetail,
  handleRedirect,
  handleRedirectTable,
  exportFile,
  redirectToImportData,
  exportFile_PK,
  submitButton_Custom,
  dataPrivileges,
  selectAllChecked,
  privilegesDetail,
  handleButtonLink,
  isParam,
  idModal,
  isParamSearch,
  _user,
  buttonId: btnId,
}) => {
  const [buttonId, setButtonId] = useState(btnId);
  let isHiddenBarCodeActivation = false;
  const params = page?.params?.map((item) => ({
    field_alias: item.field_alias,
    field_name: item.field_name,
    id: item.id,
  }));

  if (page?.old_url_format) {
    const params_value = window.location.pathname.split("/").slice(2);

    for (let i = 0; i < params?.length; i++) {
      if (params_value?.[i]) {
        params[i]["value"] = params_value[i];
      }
    }

    isHiddenBarCodeActivation = params?.length === params_value?.length;
  } else {
    const params_value = {};
    window.location.search
      .split("?")?.[1]
      ?.split("&")
      .map((param) => {
        const [key, value] = param.split("=");
        params_value[key] = value;
      });

    for (let i = 0; i < params?.length; i++) {
      const key = params[i].field_alias;
      if (params_value?.[key]) {
        params[i]["value"] = params_value[key];
      }
    }

    isHiddenBarCodeActivation =
      params?.length === Object.values(params_value)?.length;
  }
  const { lang, proxy, auth, functions, pages } = useSelector((state) => state);

  const [filteredComponents, setFilteredComponents] = useState([]);
  const _token = localStorage.getItem("_token");

  useEffect(() => {
    if (component && component.length > 0) {
      (async () => {
        let components = [];
        const conditionComponents = [];
        const apiComp = [];
        const result = {};

        for (const index in component) {
          const item = component[index];
          const { props: { apis } = {} } = item || {};
          const name = item?.name;
          if (name === "conditionComponent") {
            conditionComponents.push(item);
            for (const j in apis) {
              const {
                api: {
                  value: { remote_url, params: _paramApi, api_scope },
                },
                label,
              } = apis[j];
              let url = remote_url;
              for (const i in _paramApi) {
                const param = params.find(({ id }) => id === _paramApi[i]);
                if (param) {
                  url += `/${param.value}`;
                }
              }
              apiComp.push({ url, label, api_scope });
            }
          }
        }
        if (conditionComponents.length) {
          const response = await Promise.all(
            apiComp.map(({ url, api_scope }) =>
              fetch(`${proxy()}${url}`, {
                headers: {
                  "content-type": "application/json",
                  Authorization: _token,
                  isPage: window.location.pathname,
                },
              })
            )
          );

          for (const index in response) {
            const { data } = await response[index].json();
            result[apiComp[index].label] = data;
          }
          const conditionInstance = new Conditions({}, result);

          for (const index in conditionComponents) {
            const {
              props: { conditions: _conditions },
            } = conditionComponents[index];

            for (const j in _conditions) {
              const {
                conditions,
                failComponents,
                successComponents,
                isBreak,
                isContinue,
              } = _conditions[j];
              let isFail = false;

              for (const j in conditions) {
                const {
                  left_fields,
                  left_field_position,
                  right_fields,
                  right_field_position,
                  operator: { value: operator },
                } = conditions[j];

                const first_value = conditionInstance.convert(left_fields);
                const second_value = conditionInstance.convert(right_fields);
                const result = conditionInstance.compare(
                  { value: first_value, position: left_field_position },
                  { value: second_value, position: right_field_position },
                  operator
                );

                if (result === false) {
                  isFail = true;
                  break;
                }
              }

              if (
                (isFail && !isContinue) ||
                (!isFail && isBreak) ||
                j == _conditions.length - 1
              ) {
                for (const index in component) {
                  const item = component[index];
                  const { id } = item;
                  if (isFail) {
                    if (item.name === "grid") {
                      for (const i in item.children) {
                        const { id } = item.children[i];
                        if (failComponents.find(({ value }) => value === id)) {
                          components.push(item.children[i]);
                        }
                      }
                    } else if (
                      failComponents.find(({ value }) => value === id)
                    ) {
                      components.push(item);
                    }
                  } else {
                    if (item.name === "grid") {
                      for (const i in item.children) {
                        const { id } = item.children[i];
                        if (
                          successComponents.find(({ value }) => value === id)
                        ) {
                          components.push(item.children[i]);
                        }
                      }
                    } else if (
                      successComponents.find(({ value }) => value === id)
                    ) {
                      components.push(item);
                    }
                  }
                }
                break;
              }
            }
          }
        } else {
          components = component;
        }

        setFilteredComponents(components);
      })();
    }
  }, [component, page]);

  const [criteria, setCriteria] = useState({});
  const [quantityOfComponents, setQuantityOfComponents] = useState();
  const [isNull, setIsNull] = useState(false);
  const [refreshPage, setRefreshPage] = useState(0);
  const [isRow, setRow] = useState({});

  useEffect(() => {
    const detail_box_component = component?.filter(
      (box) => box?.name === "detail_box"
    );

    setQuantityOfComponents((prev) => ({
      actual:
        quantityOfComponents?.actual === 0
          ? 0
          : detail_box_component?.length > 0
          ? 1
          : 0,
      expect: detail_box_component?.length,
      done: 0,
    }));
  }, [component?.length]);

  useEffect(() => {
    if (quantityOfComponents) {
      if (
        quantityOfComponents.expect &&
        quantityOfComponents.done &&
        quantityOfComponents.expect === quantityOfComponents.done
      ) {
        if (quantityOfComponents.actual === 0) {
          setIsNull(true);
        }
      }
    }
  }, [quantityOfComponents]);

  const handleRefreshPage = () => {
    setRefreshPage((key) => key + 1);
  };

  if (isNull) {
    return (
      <div
        className="white_shd full"
        style={{ width: "80%", marginTop: "5px" }}
      >
        <div
          className="tabbar padding_infor_info_p-d-5"
          style={{
            textAlign: "center",
            textTransform: "uppercase",
            paddingTop: "40px",
            minHeight: "92vh",
          }}
        >
          {lang["not found"]}
        </div>
      </div>
    );
  }

  // Hàm chính để xác định loại component cần render
  const renderByType = (cpn, props, flex, id) => {
    const type = cpn?.name || cpn?.label;
    const hasFlexData = (flex) => {
      return flex && flex?.props && flex?.props?.style;
    };

    // Áp dụng style của flex cho table nếu có
    const applyFlexStyle = (style) => {
      return hasFlexData(flex) ? { ...style, ...flex?.props?.style } : style;
    };

    function findChildById(children, id) {
      return children?.find((child) => child.id === id);
    }
    const foundChild = hasFlexData(flex) && findChildById(flex?.children, id);

    const extraButtons_Param = (
      <ExtraButtons
        buttons={
          hasFlexData(flex) ? foundChild?.props?.buttons : props?.buttons
        }
        props={props}
        cpn_id={cpn?.id}
        lang={lang}
        redirectToInput={redirectToInput}
        redirectToImportData={redirectToImportData}
        exportToCSV={exportToCSV}
        exportFile={exportFile}
        dataPrivileges={dataPrivileges}
        privilegesDetail={privilegesDetail}
        setRefreshPage={setRefreshPage}
        _user={_user}
        CPN_ID={page?.component?.[0]?.id}
        isParam={isParam}
      />
    );

    if (type === "table_chart" || type === "c_chart") {
      try {
        props.source.fields = props?.field?.filter((i) => i.id) || [];
        props.buttons.export.api = props.export.api;
      } catch (e) {}
    }
    const extraButtons = (
      <ExtraButtons
        buttons={props?.buttons}
        props={props}
        export_excel_type={
          type === "table_chart" || type === "c_chart" ? "statistic" : ""
        }
        lang={lang}
        cpn_id={cpn?.id}
        redirectToInput={redirectToInput}
        redirectToImportData={redirectToImportData}
        exportToCSV={exportToCSV}
        exportFile={exportFile}
        dataPrivileges={dataPrivileges}
        privilegesDetail={privilegesDetail}
        setRefreshPage={setRefreshPage}
        _user={_user}
        CPN_ID={page?.component?.[0]?.id}
        isParam={isParam}
      />
    );

    switch (type) {
      case "button_link":
        return (
          <>
            {props.title ? (
              <label className="page-title">
                <span
                  style={{ fontSize: "18px" }}
                  onClick={() =>
                    handleButtonLink(
                      {},
                      props.to.page_id,
                      props.to.params,
                      "",
                      props.isPopup,
                      props,
                      "modalButtonLink"
                    )
                  }
                  data-toggle="modal"
                  data-target="#modalButtonLink"
                >
                  {props.title}
                </span>
              </label>
            ) : null}
            <div
              className="d-flex"
              style={{ justifyContent: props?.style?.justifyContent }}
            >
              <div
                className="d-flex"
                onClick={() =>
                  handleButtonLink(
                    {},
                    props.to.page_id,
                    props.to.params,
                    "",
                    props.isPopup,
                    props,
                    "modalButtonLink"
                  )
                }
                data-toggle="modal"
                data-target="#modalButtonLink"
              >
                <span style={props.stylePrefix}>{props.prefix}</span>
                <div className="button_link">
                  <div
                    className="icon-table-line"
                    style={{ ...props.style, justifyContent: "unset" }}
                  >
                    <FontAwesomeIcon icon={icons[props?.icon]?.icon} />
                  </div>
                </div>
                <span style={props.stylePostfix}>{props.postfix}</span>
              </div>
            </div>
          </>
        );
      case "text":
        return <div style={props.style}>{props.content}</div>;
      case "table":
        // const extraButtons = hasFlexData(flex) ? renderExtraButtons(foundChild.props.buttons, props, lang) : renderExtraButtons(props.buttons, props);
        const tableStyle = applyFlexStyle(props.style); // Áp dụng style ở đây
        return (
          <div
            style={{
              margin: tableStyle.margin,
              padding: tableStyle.padding,
              width: tableStyle.width,
            }}
          >
            <div class="d-flex align-items-center page-title position-relative mb-0">
              <span style={{ fontSize: "18px" }}>{props.name}</span>
              {extraButtons && (
                <div class="ml-auto d-flex align-items-center">
                  {extraButtons}
                </div>
              )}{" "}
            </div>
            <hr
              style={{
                border: "1px solid rgb(221, 221, 221)",
                margin: "0px -12px 5px -12px",
              }}
            />
            <RenderTable
              buttonId={buttonId}
              key={refreshPage}
              setRefreshPage={setRefreshPage}
              page={page}
              component={cpn}
              type={type}
              apiData={apiData}
              props={props}
              buttons={props.buttons}
              handleSearchClick={handleSearchClick}
              redirectToInputPUT={redirectToInputPUT}
              handleDelete={handleDelete}
              handleViewDetail={handleViewDetail}
              handleRedirect={handleRedirect}
              handleRedirectTable={handleRedirectTable}
              exportFile={exportFile}
              exportFile_PK={exportFile_PK}
              submitButton_Custom={submitButton_Custom}
              dataPrivileges={dataPrivileges}
              selectAllChecked={selectAllChecked}
              privilegesDetail={privilegesDetail}
              setRow={setRow}
              isParam={isParam}
              idModal={idModal}
              isParamSearch={isParamSearch}
              _user={_user}
              setButtonId={setButtonId}
            />
          </div>
        );

      case "table_param":
        // const extraButtons = hasFlexData(flex) ? renderExtraButtons(foundChild.props.buttons, props, lang) : renderExtraButtons(props.buttons, props);

        const tableParamStyle = applyFlexStyle(props.style); // Áp dụng style ở đây
        return (
          <div style={tableParamStyle}>
            <div
              class="d-flex align-items-center mt-2"
              style={{ fontWeight: "bold" }}
            >
              {props.name}
              {extraButtons_Param && (
                <div class="ml-auto mb-1">{extraButtons_Param}</div>
              )}
            </div>
            <RenderTable
              buttonId={buttonId}
              page={page}
              component={cpn}
              apiData={apiData}
              props={props}
              type={type}
              buttons={props.buttons}
              handleSearchClick={handleSearchClick}
              redirectToInputPUT={redirectToInputPUT}
              handleDelete={handleDelete}
              handleViewDetail={handleViewDetail}
              exportFile={exportFile}
              exportFile_PK={exportFile_PK}
              submitButton_Custom={submitButton_Custom}
              dataPrivileges={dataPrivileges}
              privilegesDetail={privilegesDetail}
              _user={_user}
            />
          </div>
        );

      case "detail_box":
        // Các logic khác cho flex
        console.log("ididid", props);
        return (
          <RenderDetail
            cpn={cpn}
            props={props}
            buttonId={buttonId}
            page={page}
            onRendering={(isRendering) => {
              setQuantityOfComponents((prev) => ({
                expect: prev.expect,
                actual: isRendering ? prev.actual + 1 : prev.actual,
                done: prev.done + 1,
              }));
            }}
            isParam={isParam}
          />
        );

      // case "barcode_activation":
      //   return params.length === Object.values(params_value).length ? (
      //     <BarCodeActivation
      //       props={props}
      //       othersPayload={{
      //         select: params.map(({ value, field_alias }) => ({
      //           key: field_alias,
      //           value,
      //         })),
      //       }}
      //       title_list={params.map((i) => `${i.field_name}: ${i.value}`)}
      //     />
      //   ) : (
      //     <PageNotFound />
      //   );
      case "barcode_activation":
        return isHiddenBarCodeActivation ? (
          <BarCodeActivation
            props={props}
            othersPayload={{
              select: params.map(({ value, field_alias }) => ({
                key: field_alias,
                value,
              })),
            }}
            title_list={params}
          />
        ) : null;
      // <PageNotFound />

      case "barcode_suggestion":
        return (
          <BarcodeSuggestion
            cpn={cpn}
            props={props}
            page={page}
            apiData={apiData}
          />
        );
      case "flex":
        // Các logic khác cho flex
        return (
          <>
            <div class="d-flex align-items-center mt-2">hi</div>
          </>
        );
      case "chart_1":
        return (
          <>
            <RenderChart
              props={props}
              dataPrivileges={dataPrivileges}
              _user={_user}
            />
          </>
        );
      case "search_component":
        return (
          <>
            {/* <h1>H1 SEARCH</h1> */}
            <SearchComponent
              {...props}
              onSearch={(payload) => {
                setCriteria(payload);
              }}
            />
          </>
        );
      case "table_chart":
        return (
          <>
            {/* {extraButtons && <div class="ml-auto mb-1">{extraButtons}</div>} */}
            <TableChart
              key={refreshPage}
              props={props}
              chart_id={cpn.id}
              criteria={criteria}
              extraButtons={extraButtons}
              dataPrivileges={dataPrivileges}
              handleRefreshPage={handleRefreshPage}
            />
          </>
        );
      case "chart_2":
        return (
          <>
            <RenderStatisBlock
              props={cpn.children}
              dataPrivileges={dataPrivileges}
            />
          </>
        );
      case "c_chart":
        return (
          <>
            {/* <div className="col-md-12" style={{border: "1px black"}}> */}
            <RenderChart
              key={refreshPage}
              props={props}
              chart_id={cpn.id}
              criteria={criteria}
              extraButtons={extraButtons}
              dataPrivileges={dataPrivileges}
              _user={_user}
              handleRefreshPage={handleRefreshPage}
            />
            {/* </div> */}
          </>
        );
      case "chart_3":
        return <StatisticChart props={props} />;
      case "grid":
        return renderByType(flex, props);
      default:
      // return <div>Unknown component type!</div>;
    }
  };

  return (
    <div class="row" style={{ margin: "5px -15px" }}>
      <div class="col-md-12">
        <div
          class="white_shd full"
          style={{
            width: page?.is_public ? "80%" : "100%",
            marginTop: page?.is_public ? "5px" : "unset",
          }}
        >
          {/* style={{width: pagePublic? '100%': '80%'}} */}
          {/* <div class="full graph_head_cus d-flex">
                        {component?.map((comp) => (
                            <div key={comp.id}>
                            </div>
                        ))}
                    </div> */}
          <div class="full inner_elements">
            <div class="tab_style2 ">
              <div
                class="tabbar padding_infor_info_p-d-5"
                style={{
                  padding: "0",
                  minHeight: idModal || isParam ? "unset" : "92vh",
                }}
              >
                <div class="tab-content" id="nav-tabContent">
                  <div
                    class={`tab-pane fade ${
                      "nav-home_s2" ? "show active" : ""
                    }`}
                    id="nav-home_s2"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div class="table_section">
                      {filteredComponents?.map((comp) => {
                        switch (comp?.name) {
                          case "grid":
                            return (
                              <div
                                className="row mt-3 mb-3"
                                style={{
                                  marginRight: "-12px",
                                  marginLeft: "-12px",
                                }}
                                key={comp.id}
                              >
                                {comp?.props?.style?.grid?.map(
                                  (data, index) => {
                                    const styles = eval(`({${data?.styles}})`);
                                    console.log("stylesstyles", styles);
                                    return (
                                      <div
                                        className={`col-sm-${data.value}`}
                                        style={styles}
                                      >
                                        {data?.child?.map((dc) => {
                                          const findId = comp?.children.find(
                                            (cs) => cs.id === dc.id
                                          );
                                          if (findId) {
                                            return renderByType(
                                              findId,
                                              findId.props,
                                              findId,
                                              findId.id
                                            );
                                          }
                                        })}
                                        {/* {comp?.children?.map((compflex) => {
                                          const findId = data?.child?.find(
                                            (d) => compflex.id === d.id
                                          );
                                          if (findId) {
                                            const newProps = {
                                              ...findId.props,
                                              ...compflex.props,
                                            };
                                            findId.props = newProps;
                                            return renderByType(
                                              compflex,
                                              compflex.props,
                                              compflex,
                                              compflex.id
                                            );
                                          } else {
                                          }
                                        })} */}
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            );
                          case "flex":
                            return (
                              <div
                                key={comp?.id}
                                style={{
                                  order: comp?.flex?.order,
                                  flexGrow: comp?.flex?.flexGrow,
                                }}
                              >
                                <div class="">
                                  {comp?.children?.map((compflex) => (
                                    <div key={compflex.id}>
                                      {renderByType(
                                        compflex,
                                        compflex.props,
                                        comp,
                                        compflex.id
                                      )}{" "}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            );
                          default:
                            return (
                              <div
                                key={comp?.id}
                                style={{
                                  order: comp?.flex?.order,
                                  flexGrow: comp?.flex?.flexGrow,
                                }}
                              >
                                {renderByType(comp, comp?.props)}
                              </div>
                            );
                        }

                        // return (
                        //   <div
                        //     key={comp?.id}
                        //     style={{
                        //       order: comp?.flex?.order,
                        //       flexGrow: comp?.flex?.flexGrow,
                        //     }}
                        //   >
                        //     {comp?.name === "flex" ? (
                        //       <div class="">
                        //         {comp?.children?.map((compflex) => (
                        //           <div key={compflex.id}>
                        //             {renderByType(
                        //               compflex,
                        //               compflex.props,
                        //               comp,
                        //               compflex.id
                        //             )}{" "}
                        //           </div>
                        //         ))}
                        //       </div>
                        //     ) : (
                        //       renderByType(comp, comp?.props)
                        //     )}
                        //   </div>
                        // );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ExtraButtons = ({
  buttons,
  props,
  redirectToInput,
  redirectToImportData,
  exportToCSV,
  exportFile,
  export_excel_type,
  dataPrivileges,
  privilegesDetail,
  setRefreshPage,
  cpn_id,
  _user,
  CPN_ID,
  isParam,
}) => {
  const { handleSetSearchingData, setIsRefresh } =
    useContext(SearchingDataContext);
  const navigate = useNavigate();
  const { lang, proxy, auth, functions } = useSelector((state) => state);
  const stringifiedUser = localStorage.getItem("user");
  // const _user = JSON.parse(stringifiedUser) || {};
  const _token = localStorage.getItem("_token");
  const [refresh, setRefresh] = useState(0);
  // const [dataPrivileges, setDataPrivileges] = useState([]);

  // useEffect(() => {
  //   fetch(`${proxy()}/privileges/accounts`, {
  //     headers: {
  //       Authorization: _token,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((resp) => {
  //       const { success, data, activated, status, content } = resp;
  //       if (success && data.length > 0) {
  //         const dataUser = data.find(
  //           (item) => item.username === _user.username
  //         );
  //         setDataPrivileges(dataUser?.privileges);
  //       }
  //     });
  // }, []);

  const dataTable_id =
    props?.source?.tables?.length > 0 && props?.source?.tables?.[0]?.id;
  const table_alias =
    props?.source?.tables?.length > 0 &&
    props?.source?.tables?.[0]?.table_alias;

  const dataCheckAdministrator = {
    read: true,
    write: true,
    sync: true,
    modify: true,
    purge: true,
    code_generating_button: true,
    redirect_button: true,
    custom_button: true,
    table_export_button: true,
  };
  const dataCheck =
    _user?.role !== "uad"
      ? dataPrivileges?.find((item) => item.table_id === dataTable_id)
      : dataCheckAdministrator;

  const handleSyncFetch = async (url, setRefreshPage, param, isType) => {
    try {
      const currentDate = moment();
      const lastMonthSameDay = currentDate
        .clone()
        .subtract(1, "months")
        .date(currentDate.date());

      const isLeapYear = lastMonthSameDay.isLeapYear();
      let dateBeforeMonth;

      if (lastMonthSameDay.month() === 1) {
        dateBeforeMonth = isLeapYear ? "29" : "28";
      } else {
        dateBeforeMonth = lastMonthSameDay.format("DD");
      }

      const formattedDate = `${dateBeforeMonth}${lastMonthSameDay.format(
        "MMYYYY"
      )}`;

      Swal.fire({
        title: "Đang đồng bộ...",
        text: "Vui lòng chờ trong giây lát.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const fetchPromises = [
        fetch(proxy() + url + `${param ? `&id=${param}` : ""}`, {
          method: "GET",
          headers: {
            Authorization: _token,
            "Content-Type": "application/json",
          },
        }),
        ...(isType
          ? [
              fetch(
                proxy() + `/api/SyncERP/ProductionOrders?date=${formattedDate}`,
                {
                  method: "GET",
                  headers: {
                    Authorization: _token,
                    "Content-Type": "application/json",
                    username: "ERP",
                  },
                }
              ),
              fetch(proxy() + `/api/SyncERP/SaleOrders?date=${formattedDate}`, {
                method: "GET",
                headers: {
                  Authorization: _token,
                  "Content-Type": "application/json",
                  username: "ERP",
                },
              }),
              fetch(
                proxy() + `/api/SyncERP/DeliveryOrder?date=${formattedDate}`,
                {
                  method: "GET",
                  headers: {
                    Authorization: _token,
                    "Content-Type": "application/json",
                    username: "ERP",
                  },
                }
              ),
            ]
          : []),
      ];

      const responses = await Promise.all(fetchPromises);
      const results = await Promise.all(responses.map((res) => res.json()));

      const [
        mainData,
        productionOrdersData,
        saleOrdersData,
        deliveryOrdersData,
      ] = results;

      const date = moment().format("DD/MM/YYYY HH:mm:ss");

      if (mainData.success === "True") {
        Swal.fire({
          icon: "success",
          title: "Thành công",
          html: `${date}<br>Đồng bộ dữ liệu thành công!<br>Data đã đồng bộ: ${mainData.data.length}`,
        }).then(() => {
          setRefreshPage((prev) => prev + 1);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Lỗi",
          html: `${date}<br>ERP phản hồi: ${
            mainData.message || mainData.description
          }`,
        });
      }
    } catch (error) {
      console.error("Fetch failed:", error);
      Swal.fire({
        icon: "error",
        title: "Lỗi",
        text: "Đã xảy ra lỗi khi đồng bộ.",
      });
    }
  };

  return Object.entries(buttons || {})
    .sort(([keyA], [keyB]) => {
      const order = ["add", "sync", "refresh", "import", "export"];
      return order.indexOf(keyA) - order.indexOf(keyB);
    })
    .map(([key, value]) => {
      const { ct = {} } = auth || {};

      const BUTTONS_FROM_DESIGN = props.buttons;
      const KEYS = {
        add: "write",
        import: "import",
        export: "export",
        sync: "sync",
      };
      if (!BUTTONS_FROM_DESIGN[key].state) {
        return null;
      }
      if (key !== "refresh") {
        if (!["pm", "uad"].includes(auth.role)) {
          for (const index in ct || []) {
            const item = ct[index];
            if (item?.cpn_id === cpn_id && !item?.[KEYS[key]]) {
              return null;
            }
          }
          if (!ct.length) return null;
        }
      }

      switch (key) {
        case "sync":
          const { CustomApi, isType } = buttons[key];
          let param = "";
          return (
            <>
              <img
                src="/images/sync.webp"
                width={27}
                height={27}
                className="icon-add mr-2 pointer"
                data-toggle="modal"
                data-target="#isType"
                title={lang["sync"]}
                onClick={async () => {
                  setRefresh((prev) => prev + 1);
                  if (isType) return;
                  const result = await Swal.fire({
                    title: "Xác nhận",
                    text: "Bạn có chắc muốn đồng bộ dữ liệu?",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Đồng Bộ",
                    cancelButtonText: "Hủy",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                  });

                  if (result.isConfirmed) {
                    handleSyncFetch(CustomApi, setRefreshPage);
                  }
                }}
              />
              {isType && (
                <div
                  class="modal fade"
                  id="isType"
                  tabindex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div
                        class="modal-header"
                        style={{
                          display: "unset",
                        }}
                      >
                        Mã Sản Phẩm<span style={{ color: "red" }}>*</span>:
                      </div>
                      <div class="modal-body">
                        <input
                          key={refresh}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            param = e.target.value;
                          }}
                        />
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          data-dismiss="modal"
                        >
                          {lang["btn.close"]}
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          onClick={() => {
                            if (!param) {
                              Swal.fire({
                                icon: "error",
                                title: "Lỗi",
                                html: `Vui lòng nhập Mã Sản Phẩm!`,
                              });
                            } else {
                              handleSyncFetch(
                                CustomApi,
                                setRefreshPage,
                                param,
                                isType
                              );
                            }
                          }}
                        >
                          {lang["sync"]}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* <FontAwesomeIcon
                icon={faDatabase}
                key={key}
                fontSize={27}
                className="icon-add mr-2 pointer"
                style={{ fontSize: "27px", color: "#3e748a" }}
                title={lang["Refesh"]}
                onClick={async () => {
                  const result = await Swal.fire({
                    title: "Xác nhận",
                    text: "Bạn có chắc muốn đồng bộ dữ liệu?",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Đồng Bộ",
                    cancelButtonText: "Hủy",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                  });

                  if (result.isConfirmed) {
                    handleSyncFetch(CustomApi);
                  }
                }}
              /> */}
            </>
          );
        case "refresh":
          return (
            <FontAwesomeIcon
              icon={faRetweet}
              key={key}
              onClick={() => {
                handleSetSearchingData("");
                setIsRefresh((prev) => !prev);
                setRefreshPage((prev) => prev + 1);
              }}
              className="icon-add mr-2 pointer"
              title={lang["Refresh"]}
              style={{ fontSize: "27px", color: "#e0762a" }}
            />
          );
        case "add":
          return (
            <FontAwesomeIcon
              icon={faCirclePlus}
              title={lang["create"]}
              className="icon-add mr-2 pointer"
              style={{ fontSize: "27px" }}
              onClick={() => {
                if (buttons.add.CustomUrl) {
                  navigate(buttons.add.CustomUrl);
                } else {
                  redirectToInput(
                    props,
                    buttons.add.api.api_id,
                    setRefreshPage
                  );
                }
              }}
              data-toggle="modal"
              data-target="#modalAdd"
            />
          );
        case "import":
          return (
            <>
              <FontAwesomeIcon
                icon={faUpload}
                className={`size-24 mr-2 icon-import pointer `}
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                title={lang["import data"]}
                style={{ fontSize: "27px" }}
              />
              <input type="file" style={{ display: "none" }} />
              <ul
                class="dropdown-menu "
                aria-labelledby="navbarDropdownMenuLink"
              >
                <li>
                  <span
                    class="dropdown-item"
                    onClick={
                      () => {
                        const url = window.location.pathname;
                        navigate(
                          `${url}/import/${props.buttons.import.api.api_id}`
                        );
                      }
                      // redirectToImportData(
                      //   props.buttons.import.api.url.split("/")[2],
                      //   props.source.get.url,
                      //   props.buttons.add.api
                      // )
                    }
                  >
                    {lang["import file"]}
                  </span>
                </li>
                <li class="dropdown-submenu dropdown-submenu-left">
                  <a class="dropdown-item dropdown-toggle" href="#">
                    File mẫu
                  </a>
                  <ul class="dropdown-menu first-sub-menu">
                    <li
                      onClick={() =>
                        exportToCSV("xlsx", props?.source?.tables?.[0]?.fields)
                      }
                    >
                      <span class="dropdown-item">Excel</span>
                    </li>
                    <li
                      onClick={() =>
                        exportToCSV("csv", props?.source?.tables?.[0]?.fields)
                      }
                    >
                      <span class="dropdown-item">CSV</span>
                    </li>
                  </ul>
                </li>
              </ul>
            </>
          );
        case "export":
          if (export_excel_type === "statistic") {
            return (
              <div
                className="btn btn-success style-btn d-flex"
                onClick={() => {
                  exportFile(
                    (props?.source?.DisplayFields
                      ? props?.source?.DisplayFields?.map(
                          ({ field, label, value }) =>
                            field || {
                              fomular_alias: label,
                              field_name: label,
                            }
                        )
                      : props?.source?.fields) || [],
                    props?.source?.get?.url || "",
                    buttons.export.api.url,
                    export_excel_type,
                    props
                  );
                }}
                data-toggle="modal"
                data-target="#exportExcel"
                data-backdrop="static"
                title={lang["export_excel_excel"]}
              >
                <FontAwesomeIcon
                  icon={faDownload}
                  className="icon-export pointer"
                  style={{ fontSize: "27px" }}
                />
                <div className="ml-1">{lang["export"]}</div>
              </div>
            );
          }
          return (
            <FontAwesomeIcon
              icon={faDownload}
              className="icon-export mr-2 pointer margin-bottom-1"
              style={{ fontSize: "27px" }}
              onClick={() => {
                exportFile(
                  (props?.source?.DisplayFields
                    ? props?.source?.DisplayFields?.map(
                        ({ field, label, value, id }, f) => {
                          const matchedItem =
                            props?.source?.display_fields.find(
                              (item) => item.field_name === label
                            );
                          return (
                            field || {
                              fomular_alias: label,
                              field_name: label,
                              id,
                              value,
                              type: matchedItem,
                            }
                          );
                        }
                      )
                    : props?.source?.fields) || [],
                  props?.source?.get?.url || "",
                  buttons.export.api.url,
                  export_excel_type,
                  props,
                  "",
                  isParam,
                  CPN_ID
                );
              }}
              data-toggle="modal"
              data-target="#exportExcel"
              data-backdrop="static"
              title={lang["export_excel_excel"]}
            />
          );
          break;
        default:
          break;
        // Thêm các trường hợp khác
      }
      return null;
    })
    .filter(Boolean);
};

const RenderTable = (props) => {
  const { project_id, version_id, url } = useParams();

  const {
    dataPrivileges,
    component,
    selectAllChecked,
    setRefreshPage,
    isParam,
    idModal,
    isParamSearch,
    _user,
    setButtonId,
    buttonId,
  } = props;

  const params_Table = props.page.params;
  const tableProps = props.props;
  const children = props.component.children;
  const buttons = props.buttons;
  const exportFile = props.exportFile;
  const exportFile_PK = props.exportFile_PK;
  const redirectToInputPUT = props.redirectToInputPUT;
  const submitButton_Custom = props.submitButton_Custom;
  const handleViewDetail = props.handleViewDetail;
  const handleRedirect = props.handleRedirect;
  const handleRedirectTable = props.handleRedirectTable;
  const handleDelete = props.handleDelete;
  const stringifiedUser = localStorage.getItem("user");
  // const _user = JSON.parse(stringifiedUser) || {};
  const dataTable_id = tableProps.source.tables?.[0]?.id;
  const dispatch = useDispatch();
  const typeTable = props.type;
  const data = props.apiData;
  const setRow = props.setRow;
  const { lang, proxy, auth, functions, page, database } = useSelector(
    (state) => state
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const { openTab, normalizeStringAccent, normalizeString } = functions;
  const checkState = useSelector((state) => state.stateAprove);
  const _token = localStorage.getItem("_token");
  const privilegesDetail = props.privilegesDetail;
  const {
    isRefresh,
    searchingData: searchValues,
    handleSetSearchingData: setSearchValues,
  } = useContext(SearchingDataContext);

  const [sort, setSort] = useState();
  const [apiData, setApiData] = useState([]);
  const [previousSearchValues, setPreviousSearchValues] = useState({});
  const [currentCount, setCurrentCount] = useState(null);
  const [isModalUpdateByCondition, setModalUpdateByCondition] = useState(false);
  let {
    fields,
    search,
    get,
    calculates,
    DisplayFields,
    added_fields,
    display_fields,
    tables,
  } = tableProps.source;

  const navigate = useNavigate();
  const { FIELDS } = tableProps;
  const currentURL = window.location.href;
  const params = functions.getAllParamsAfterPageId(currentURL, url);

  const visibility = tableProps.visibility;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchUrl, setSearchUrl] = useState("");
  const [getUrl, setGetUrl] = useState("");
  const [loadingResult, setLoadingResult] = useState(true);
  const [sumerize, setSumerize] = useState(0);
  // const [dataPrivileges, setDataPrivileges] = useState([]);
  const [tableMaxHeight, setTableMaxHeight] = useState("50vh");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(true);
  const [isRegexSearching, setIsRegexSearching] = useState({});
  const debounceTimeout = useRef(null);
  const [filterWidth, setFilterWidth] = useState(0);
  const [filterHeight, setFilterHeight] = useState(0);
  const [tableFilter, setTableFilter] = useState(false);
  const [loadingPermission, setLoadingPermission] = useState(true);
  const [isAccordionTable, setAccordionTable] = useState(false);
  const isSelected = useRef();
  const isArrayData = useRef();
  const dataFilter = [];
  const dataCal = [];
  const CPN_ID = useRef();
  // const FIELDS = component.props.FIELDS;
  useEffect(() => {
    setSearchValues("");
    function updateTableHeight() {
      const newHeight = window.innerHeight - 280;
      setTableMaxHeight(`${newHeight}px`);
    }
    window.addEventListener("resize", updateTableHeight);
    // Gọi ngay khi component được mount
    updateTableHeight();
    // Cleanup listener
    return () => {
      window.removeEventListener("resize", updateTableHeight);
    };
  }, []);

  useEffect(() => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    console.log("WHATHREEE", searchValues);
    const url = sort ? search.url : searchUrl ? searchUrl : search.url;
    debounceTimeout.current = setTimeout(() => {
      if (
        (searchValues && Object.values(searchValues).length && url) ||
        (sort && Object.values(sort).length > 0)
      ) {
        callApi(searchValues, url);
      } else if (!searchValues) {
        callApi(searchValues, url);
      }
    }, 700);
  }, [searchValues, searchUrl, sort]);

  // useEffect(() => {
  //   if (Object.values(sort).length) {
  //     callApi({}, search.url);
  //   }
  // }, [sort]);

  useEffect(() => {
    if (isRefresh !== undefined) {
      handleSearchClick({}, searchUrl);
    }
  }, [isRefresh]);

  const dataCheckAdministrator = {
    read: true,
    write: true,
    modify: true,
    purge: true,
  };

  const dataCheck =
    _user?.role !== "uad"
      ? dataPrivileges?.find((item) => item.table_id === dataTable_id)
      : dataCheckAdministrator;
  let checkKey = null;
  const checkTableId = privilegesDetail.find(
    (item) => item.tables?.[0]?.tableId === dataTable_id
  );
  if (checkTableId) {
    checkKey = checkTableId?.tables?.[0]?.buttons.find((btn) =>
      btn.id.includes("read")
    );
  }

  useEffect(() => {
    if (
      (dataCheck && !checkKey?.grantted) ||
      dataCheck?.read === false ||
      (!checkKey?.grantted && dataCheck?.read === false)
    ) {
      setLoadingPermission(false);
    }
  }, [checkKey, dataCheck, loadingPermission]);

  const handleSearchClick = (data, url) => {
    setSearchUrl(url);
    setSearchValues(data);
    setCurrentPage(1);
    callApi(searchValues, searchUrl);
  };

  //searching
  useEffect(() => {
    let timeout;
    if (loadingSearch && searchValues && Object.values(searchValues).length) {
      Swal.fire({
        title: lang["searching"],
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [loadingSearch]);

  ///Loading
  // useEffect(() => {
  //   let timeout;
  //   if (!loadingSearch && loading) {
  //     Swal.fire({
  //       title: lang["loading"],
  //       allowEscapeKey: false,
  //       allowOutsideClick: false,
  //       didOpen: () => {
  //         Swal.showLoading();
  //       },
  //     });
  //   } else {
  //     timeout = setTimeout(() => {
  //       Swal.close();
  //     }, 500);
  //   }
  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // }, [loading]);
  const [searchedField, setSearchedField] = useState({});

  const handleInputChange = (
    e,
    fieldAlias,
    value,
    searchData,
    label,
    isRegexSearching,
    searchedField
  ) => {
    let trimmedValue = [];
    if (Array.isArray(value)) {
      trimmedValue = value?.map((item) => {
        const stringValue =
          typeof item.value === "string" ? item.value : String(item.value);
        return stringValue;
      });
    } else if (typeof value === "object") {
      trimmedValue = value;
    } else {
      const stringValue = typeof value === "string" ? value : String(value);
      trimmedValue = stringValue;
    }
    if (searchedField?.value) {
      setSearchedField((prev) => {
        if (!trimmedValue) {
          delete prev[label.split("-$")[1] || label.split("-")[0]];
          return { ...prev };
        }
        return {
          ...prev,
          [label.split("-$")[1] || label.split("-")[0]]: searchedField.value,
        };
      });
    }
    setSearchValues((prevValues) => {
      const newValues = { ...prevValues };

      if (label) {
        if (value) {
          const newLabel = label?.split("-[")[0];
          newValues[label] = trimmedValue;
        } else {
          delete newValues[label];
        }
      } else {
        if (value) {
          newValues[fieldAlias] = trimmedValue;
        } else {
          delete newValues[fieldAlias];
        }
      }
      if (Object.keys(newValues).length === 0) {
        return;
      }
      return newValues;
    });

    if (isRegexSearching) {
      setIsRegexSearching((prev) => ({
        ...prev,
        [label.split("-$")[1] || label.split("-")[0]]: isRegexSearching,
      }));
    }

    // Cập nhật searchUrl
    setSearchUrl(searchData.url);
  };

  // Hàm xử lý sự kiện nhấn phím, ví dụ nhấn Enter để tìm kiếm
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchClick(searchValues, searchUrl);
    }
  };

  const hasInlineButtons = Object.keys(buttons || {}).some(
    (key) => buttons[key].state && !["add", "import", "export"].includes(key)
  );

  const [totalPages, setTotalPages] = useState(0);

  const rowsPerPage = functions.findRowsPerPage(tableProps);

  const accurateTotalPages = Math.ceil(sumerize / rowsPerPage) || totalPages;
  const [isForbidden, setIsForbidden] = useState(false);
  const [isCalculating, setIsCalculating] = useState(false);

  if (totalPages !== accurateTotalPages) {
    setTotalPages(accurateTotalPages);
  }
  const indexOfLast = currentPage * rowsPerPage;

  const indexOfFirst = indexOfLast - rowsPerPage;

  const currentData = apiData;

  // thinh them is Loading
  // const [isLoading, setIsLoading] = useState(false);
  // day la ham can viet thinh
  const paginate = (pageNumber, isFirstOrLastPage) => {
    setAccordionTable({})
    setIsLoading(true);
    const startAt = (pageNumber - 1) * rowsPerPage;
    if (searchValues && Object.keys(searchValues).length === 0) {
      callApiView(getUrl, startAt, rowsPerPage);
    } else {
      callApiPa(pageNumber - 1, searchValues);
    }
    setCurrentPage(pageNumber);
  };

  const renderSourceButtons = (source, lang) => {
    return Object.entries(source)
      .map(([key, value]) => {
        if (!value.state) {
          return null;
        }
        switch (key) {
          case "search":
            return (
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                key={key}
                onClick={() =>
                  handleSearchClick(searchValues, source.search.url)
                }
                className="icon-add mr-2 pointer"
              />
            );
            break;
        }
        return null;
      })
      .filter(Boolean);
  };

  const handleSetAPIData = (data) => {
    let newData = data;
    if (props.props.source.calculates.length) {
      newData = data.map((item) => {
        props.props.source.calculates.map(
          ({ fomular, fomular_alias, display_name }) => {
            let value = "";
            if (fomular) {
              const outputString = Calculation.mappingKey(item, fomular);
              value = Calculation.calculate(outputString);
            }
            item[fomular_alias] = value;
          }
        );
        return item;
      });
    }
    setApiData(newData.filter((record) => record != undefined));
  };

  useEffect(() => {
    if (get) {
      setGetUrl(get.url);
      callApiView(get.url);

      dispatch({
        branch: "ui",
        type: "checkState",
        payload: {
          success: false,
        },
      });
    }
  }, [isParam]);

  const callApiView = (url, startAt = 0, amount = rowsPerPage) => {
    if (typeTable === "table_param") {
      const url = tableProps.source.search.url;
      const result = params_Table?.reduce((acc, item, index) => {
        if (index < params.length) {
          acc[item.fomular_alias] = params[index];
        }
        return acc;
      }, {});
      setSearchValues(result);
      setCurrentPage(1);
      callApi(result, url);
      setApiData([]);
      setSumerize(0);
      return;
    }

    if (url) {
      const headerApi = {
        Authorization: _token,
        "start-at": startAt,
        "data-amount": amount,
      };

      let params = window.location.pathname
        .slice(1)
        .replace(props.page.page_id, "");

      if (!props.page?.old_url_format) {
        params += "/";
        window.location.search
          .slice(1)
          .split("&")
          .map((item) => {
            const [key, value] = item.split("=");
            if (value) {
              params += value;
            } else {
              params += isParam;
            }
          });
      }
      // setLoadingResult(false);

      fetch(
        `${proxy()}/total/${tableProps.source.get.api_id}${params}/?cpn_id=${
          props.page.component[0].id
        }&buttonId=${props.buttonId}`,
        {
          headers: headerApi,
          method: "POST",
        }
      )
        .then((res) => res.json())
        .then((res) => {
          const { total } = res;
          setSumerize(total);
        })
        .finally(() => setLoadingResult(false));
      fetch(
        `${proxy()}${url}${params}/?cpn_id=${
          props.page.component[0].id
        }&buttonId=${props.buttonId}`,
        {
          headers: headerApi,
        }
      )
        .then((res) => res.json())
        .then((res) => {
          const { success, data, count, code } = res;
          setApiData([]);

          // setSumerize(count);
          if (success && data && data.length > 0) {
            handleSetAPIData(data);
            setIsLoading(false);
          } else if (res.content === "403 - Forbidden") {
            setIsForbidden(true);
          } else if (code === 111) {
            setIsCalculating(true);
          }
        })
        .finally(() => {
          setIsLoading(false);
          setLoadingTable(false);
        });
    } else {
      setLoadingTable(false);
    }
  };

  const callApi = (data, dataUrl, startIndex = currentPage - 1) => {
    const startTime = new Date().getTime();
    let loadingTimeout;
    let loadingTimeoutSearch;

    // if (Object.keys(data).length !== 0) {
    //   loadingTimeoutSearch = setTimeout(() => {
    if (dataUrl) {
      setLoadingSearch(true);
    }
    //   }, 310);
    // }

    let filtered_searchValues = {};

    let mappData = [];
    DisplayFields.map(({ search_fields }) => {
      for (const k in search_fields) {
        let alias = search_fields[k].label
          ?.split("-$")
          ?.at(-1)
          ?.split(".")
          ?.at(-1);
        alias = alias?.[0] === "$" ? alias.slice(1) : alias;
        const newData = {
          alias: alias,
          data: search_fields[k].field,
        };

        mappData.push(newData);
      }
    });
    for (const k in data) {
      let aliasK = k.split("-$")?.at(-1)?.split(".")?.at(-1);

      aliasK = aliasK[0] === "$" ? aliasK.slice(1) : aliasK;
      const field = mappData.find(({ alias }) => alias === aliasK);

      if (["DATE", "DATETIME"].includes(field?.data?.DATATYPE)) {
        filtered_searchValues[k.split("-$").at(-1)] = data[k];
      } else if (data[k] && !data[k].from && !data[k].to) {
        let value = normalizeStringAccent(data[k]);

        if (
          ["INT UNSIGNED", "INT", "DECIMAL"].includes(field?.data?.DATATYPE)
        ) {
          value = isNaN(Number(data[k]))
            ? normalizeStringAccent(data[k])
            : Number(data[k]);
        }
        filtered_searchValues[k.split("-$").at(-1)] = value;
      }
    }
    const searchBody = {
      start_index: 0,
      criteria: filtered_searchValues,
      require_count: false,
      require_statistic: false,
      isRegexSearching,
      sort,
      searchedField,
      is_hidden: page?.is_hidden,
    };

    let params_mapped = {};

    if (page?.old_url_format) {
    } else {
      for (let entry of searchParams.entries()) {
        params_mapped[entry[0]] = entry[1];
      }
    }

    if (dataUrl) {
      setLoadingResult(true);
      fetch(
        `${proxy()}/total/${dataUrl.split("/")[2]}/${
          isParamSearch ? isParamSearch : window.location.search
        }/?cpn_id=${props.page.component[0].id}&buttonId=${props.buttonId}`,
        {
          method: "POST",
          headers: {
            "content-type": "application/json",
            Authorization: _token,
          },
          body: JSON.stringify(searchBody),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setTotalPages(res.total);
          setCurrentCount(res.total ?? 0);
          setSumerize(res.total ?? 0);
        })
        .finally(() => {
          setLoadingResult(false);
          setLoadingSearch(false);
          setCurrentPage(1);
        });

      fetch(
        `${proxy()}${dataUrl}\\${
          isParamSearch ? isParamSearch : window.location.search
        }`,
        {
          method: "POST",
          headers: {
            "content-type": "application/json",
            Authorization: _token,
            fromIndex: currentPage - 1,
            "data-amount": rowsPerPage,
          },
          body: JSON.stringify(searchBody),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          const {
            success,
            content,
            data,
            result,
            total,
            fields,
            count,
            sumerize,
          } = res;
          // setCurrentCount(count ?? 0);
          // setSumerize(count ?? 0);
          // setTotalPages(total);
          if (success) {
            handleSetAPIData(data);
          }
        })
        .finally(() => {
          clearTimeout(loadingTimeout);
          clearTimeout(loadingTimeoutSearch); // Clear the timeout
          setLoadingSearch(false);
          setLoading(false);
          setCurrentPage(1);
        });
    }
  };
  const [isLoading, setIsLoading] = useState(false);

  const callApiPa = (
    startIndex = currentPage - 1,
    searchValues
    // setIsLoading
  ) => {
    // setIsLoading(true)
    const startTime = new Date().getTime();
    let loadingTimeout;
    let loadingTimeoutSearch;

    const filtered_searchValues = {};
    for (const k in searchValues) {
      if (searchValues[k]) {
        let value = searchValues[k];
        let mappData = [];
        DisplayFields.map(({ search_fields }) => {
          for (let k in search_fields) {
            let alias = search_fields[k].label?.split("-$")?.at(1);
            const newData = {
              alias: alias,
              data: search_fields[k].field,
            };
            mappData.push(newData);
          }
        });
        const field = mappData.find(
          ({ alias }) => alias === k.split("-$")?.at(1)
        );

        if (
          ["INT UNSIGNED", "INT", "DECIMAL"].includes(field?.data?.DATATYPE)
        ) {
          value = isNaN(Number(searchValues[k]))
            ? searchValues[k]
            : Number(searchValues[k]);
        }

        filtered_searchValues[k.split("-$").at(-1)] = value;
      }
    }
    const searchBody = {
      start_index: startIndex,
      criteria: filtered_searchValues,
      require_count: false,
      require_statistic: false,
      searchedField,
      isRegexSearching,
      sort,
    };

    ////////////////console.log("ĐÂY LÀ BODY:", searchBody)
    if (searchUrl) {
      let params = window.location.pathname
        .slice(1)
        .replace(props.page.page_id, "");

      if (!props.page?.old_url_format) {
        params += "/";
        window.location.search
          .slice(1)
          .split("&")
          .map((item) => {
            const [key, value] = item.split("=");
            if (value) {
              params += value;
            } else {
              params += isParam;
            }
          });
      }

      fetch(`${proxy()}${searchUrl + params}`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: _token,
          fromIndex: currentPage - 1,
          "data-amount": rowsPerPage,
        },
        body: JSON.stringify(searchBody),
      })
        .then((res) => res.json())
        .then((res) => {
          const {
            success,
            content,
            data,
            result,
            total,
            fields,
            count,
            sumerize,
          } = res;
          const statisticValues = res.statistic;

          if (success) {
            // setCurrentCount(count ?? 0);
            // setSumerize(count ?? 0)
            handleSetAPIData(data);
            // setDataStatis(statisticValues);
            setIsLoading(false);
            // if (data.length < 15) {
            //     setTotalPages(currentPage);
            // } else if (currentPage === totalPages) {
            //     setTotalPages(prevTotalPages => prevTotalPages + 1);
            // }
          } else {
            // setApiData([]);
            // setApiDataName([])
          }

          const endTime = new Date().getTime();
          const elapsedTime = endTime - startTime;
          clearTimeout(loadingTimeout);
          clearTimeout(loadingTimeoutSearch); // Clear the timeout
          // setLoadingSearch(false);
          // setLoading(false)
          // //////////////////console.log(`---------------------------------TimeResponse: ${elapsedTime} ms`);
        });
    }
  };

  const callApiCount = (data, url, requireCount = false) => {
    // console.log("HERE 2");
    const startTime = new Date().getTime();
    let loadingTimeout;
    let loadingTimeoutSearch;
    // if (Object.keys(searchValues).length !== 0) {
    //     loadingTimeoutSearch = setTimeout(() => {
    //         setLoadingSearch(true);
    //     }, 310);
    // }
    if (JSON.stringify(searchValues) !== JSON.stringify(previousSearchValues)) {
      setPreviousSearchValues(searchValues);
      requireCount = true;
    }

    const filtered_searchValues = {};
    for (const k in searchValues) {
      let aliasK = k.split(".")?.at(-1);

      if (searchValues[k]) {
        let value = searchValues[k];
        let mappData = [];
        DisplayFields.map(({ search_fields }) => {
          for (const k in search_fields) {
            let alias = search_fields[k].label
              ?.split("-$")
              ?.at(-1)
              ?.split(".")
              ?.at(-1);
            alias = alias[0] === "$" ? alias.slice(1) : alias;
            const newData = {
              alias: alias,
              data: search_fields[k].field,
            };

            mappData.push(newData);
          }
        });
        const field = mappData.find(({ alias }) => alias === aliasK);

        if (["INT UNSIGNED", "INT"].includes(field?.data?.DATATYPE)) {
          value = isNaN(Number(searchValues[k]))
            ? searchValues[k]
            : Number(searchValues[k]);
        }

        filtered_searchValues[k] = value;
      }
    }

    const searchBody = {
      // table_id: dataTable_id,
      start_index: currentPage - 1,
      criteria: filtered_searchValues,
      require_count: true,
      require_statistic: false,
      searchedField,
      // api_id: page.components?.[0]?.api_get.split('/')[2]
      // exact: true
    };

    if (url) {
      loadingTimeout = setTimeout(() => {
        // setLoading(true)
        setLoadingResult(true);
      }, 30);
      fetch(`${proxy()}${url}`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: _token,
          fromIndex: currentPage - 1,
        },
        body: JSON.stringify(searchBody),
      })
        .then((res) => res.json())
        .then((res) => {
          const {
            success,
            content,
            data,
            result,
            total,
            fields,
            count,
            sumerize,
          } = res;
          const statisticValues = res.statistic;

          if (success) {
            // setApiData(data.filter(record => record != undefined));
            // setApiDataName(fields);
            // setDataStatis(statisticValues);
            // setLoaded(true);
            if (count !== undefined) {
              setCurrentCount(count);
              setSumerize(count);
            } else if (count === undefined && sumerize !== undefined) {
              setSumerize(sumerize);
            } else if (!requireCount && currentCount != null) {
              setSumerize(currentCount);
            }
          } else {
            setApiData([]);
            // setApiDataName([])
          }
          const endTime = new Date().getTime();
          const elapsedTime = endTime - startTime;
          clearTimeout(loadingTimeout);
          clearTimeout(loadingTimeoutSearch); // Clear the timeout
          setLoadingResult(false);
          // setLoadingSearch(false);
          // setLoading(false)
          //console.log(`---------------------------------TimeResponse: ${elapsedTime} ms`);
        });
    }
  };

  const headerRefs = useRef([]);
  const widthRef = useRef([]);
  useLayoutEffect(() => {
    headerRefs.current.forEach((ref) => {
      if (ref) {
        const maxWidth = parseInt(getComputedStyle(ref).maxWidth, 10);
        const minWidth = Math.min(ref.scrollWidth, maxWidth);
        ref.style.minWidth = `${minWidth}px`;
      }
    });
  }, []);

  fields = [
    ...(fields || []),
    ...(calculates?.map(({ display_name, ...props }) => ({
      field_name: display_name,
      ...props,
    })) || []),
  ];

  const handleToggleAccordion = (index) => {
    setAccordionTable((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const widthRefAccordionTable = useRef(0);
  return (
    <>
      {/* {isModalUpdateByCondition && <ModalUpdateByCondition />} */}
      <div
        className="table-display d-flex"
        style={{ minHeight: idModal || isParam ? "unset" : "78vh" }}
      >
        <div
          class="table-responsive table-custom design-table"
          style={{ height: idModal || isParam ? "unset" : "80vh" }}
          ref={(el) => {
            if (el) {
              widthRefAccordionTable.current = el.offsetWidth;
            }
          }}
        >
          {/* thinh this is where to fix */}
          {isLoading ? (
            <img
              width={40}
              className="loading-image"
              src="/images/icon/load.gif"
              alt="Loading..."
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}
            />
          ) : (
            <Table>
              <thead>
                <tr>
                  {DisplayFields.some(
                    (item) =>
                      item.condition_fields && item.condition_fields.length > 0
                  ) && apiData.some((item) => item.isEmpty) ? (
                    <td className="index"></td>
                  ) : null}
                  {visibility.indexing && (
                    <td className="index align-center" style={{ zIndex: "9" }}>
                      #
                    </td>
                  )}
                  {DisplayFields?.map((field, index) => {
                    const findSelect = field.search_fields.filter(
                      (item) => item.isSelect
                    );
                    return (
                      <td key={field.id}>
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            {field.label}
                            {/* {findSelect && findSelect.length > 0 && ( */}

                            {/* )} */}
                          </span>
                          <>
                            {findSelect && findSelect.length > 0 && (
                              <i
                                className="fa fa-filter icon-view block ml-auto"
                                onClick={() =>
                                  setTableFilter((prev) => ({
                                    [index]: !prev[index],
                                  }))
                                }
                              />
                            )}
                          </>
                        </div>
                      </td>
                    );
                  })}
                  {hasInlineButtons && (
                    <td
                      class="align-center position-sticky"
                      style={{ right: 0 }}
                    >
                      <span>{lang["Actions"]}</span>
                    </td>
                  )}
                </tr>
              </thead>
              <tbody>
                <tr className="sticky">
                  {DisplayFields.some(
                    (item) =>
                      item.condition_fields && item.condition_fields.length > 0
                  ) && apiData.some((item) => item.isEmpty) ? (
                    <td className="index"></td>
                  ) : null}
                  {visibility.indexing && <td className="index"></td>}
                  {DisplayFields?.map(({ search_fields }, index) => {
                    return (
                      <th
                        key={index}
                        ref={(el) => {
                          headerRefs.current[index] = el;
                          if (el) {
                            widthRef.current[index] = el.offsetWidth;
                          }
                        }}
                        className="header-cell search"
                        style={{ width: "400px" }}
                      >
                        {(() => {
                          //search_fields: [{},{},{}]
                          // Take the first item and render the search input, because a column have multiple value.
                          if (!search_fields || !search_fields.length) {
                            return null;
                          }

                          search_fields = [search_fields[0]];
                          return search_fields.map(
                            ({
                              field,
                              label,
                              isSelect,
                              isRegexSearching,
                              searchedField,
                            }) => {
                              const currentFilter = tableFilter[index];
                              const currentWidth = widthRef.current.find(
                                (item, i) => tableFilter[i]
                              );
                              isSelected.current = isSelect;

                              if (currentFilter) {
                                dataFilter.push({
                                  field,
                                  handleInputChange,
                                  searchValues,
                                  search,
                                  handleKeyDown,
                                  label,
                                  isSelect,
                                  isRegexSearching,
                                  isRefresh,
                                  widthRef,
                                  lang,
                                  tableFilter,
                                  currentWidth,
                                });
                              }
                              return field ? (
                                <>
                                  {tableFilter[index] ? (
                                    <div
                                      className="position-absolute"
                                      style={{ top: "-15px" }}
                                    >
                                      <FilterData
                                        dataFilter={dataFilter}
                                        dataCal={dataCal}
                                        setFilterWidth={setFilterWidth}
                                        filterWidth={filterWidth}
                                        onChange={(type) => {
                                          const search_field =
                                            label.split("-$")[1];
                                          setSort((prev) => ({
                                            ...prev,
                                            [search_field]: type,
                                          }));
                                        }}
                                        title={lang["log.listtitle"]}
                                        setTableFilter={setTableFilter}
                                        index={index}
                                        idModal={idModal}
                                        isParam={isParam}
                                      />
                                    </div>
                                  ) : null}
                                  {functions.renderInput(
                                    field,
                                    handleInputChange,
                                    searchValues,
                                    search,
                                    handleKeyDown,
                                    label,
                                    isSelect,
                                    isRegexSearching,
                                    isRefresh,
                                    widthRef,
                                    lang,
                                    searchedField
                                  )}
                                </>
                              ) : null;
                            }
                          );
                        })()}
                      </th>
                    );
                  })}
                  <th
                    class="align-center actions"
                    style={{
                      right: 0,
                      background: "#fff",
                      zIndex: Object.values(tableFilter)?.[0] ? -1 : 8,
                    }}
                  >
                    {renderSourceButtons(
                      tableProps?.source,
                      tableProps?.source?.search?.url
                    )}
                  </th>
                </tr>
                {currentData && currentData.length > 0 ? (
                  apiData?.map((row, index) => {
                    if (row) {
                      const matchedField = DisplayFields.some(
                        (item) =>
                          item.condition_fields &&
                          item.condition_fields.length > 0
                      );
                      return (
                        <>
                          <tr key={index}>
                            {(isArrayData.current &&
                              isArrayData.current.length > 0) ||
                            (matchedField &&
                              apiData.some((item) => item.isEmpty)) ? (
                              <td
                                onClick={() =>
                                  row?.isEmpty && handleToggleAccordion(index)
                                }
                              >
                                {row?.isEmpty ? (
                                  <img
                                    src={
                                      isAccordionTable[index]
                                        ? `images/detail_minus.svg`
                                        : `images/detail_plus.svg`
                                    }
                                    width={20}
                                    height={20}
                                  />
                                ) : null}
                              </td>
                            ) : null}
                            <td
                              className="index align-center"
                              scope="row"
                              style={{
                                minWidth: "50px",
                              }}
                            >
                              {indexOfFirst + index + 1}
                            </td>
                            {DisplayFields?.map(
                              (
                                {
                                  value,
                                  redirect_fields,
                                  fontSize,
                                  color,
                                  isModal,
                                  textDecoration,
                                  fontWeight,
                                  api_fields,
                                  condition_fields,
                                  update_fields,
                                  modal_title,
                                  is_data_array,
                                  background_color,
                                },
                                index
                              ) => {
                                const data = [];
                                return (
                                  <td key={index} className="cell">
                                    {(() => {
                                      value &&
                                        value.map(
                                          ({ label, value }, _index) => {
                                            let alias = label
                                              ?.split("-$")
                                              ?.at(-1)
                                              ?.split(".")
                                              ?.at(-1);
                                            alias =
                                              alias[0] === "$"
                                                ? alias.slice(1)
                                                : alias;

                                            const header = FIELDS?.find(
                                              ({ fomular_alias }) =>
                                                fomular_alias === alias
                                            );
                                            const currentFilter =
                                              tableFilter[index];
                                            if (currentFilter) {
                                              dataCal.push(row[value]);
                                            }
                                            if (header?.DATATYPE === "FILE") {
                                              if (
                                                Array.isArray(
                                                  functions.renderData(
                                                    header,
                                                    row,
                                                    value
                                                  )
                                                ) &&
                                                functions?.renderData(
                                                  header,
                                                  row,
                                                  value
                                                ) &&
                                                functions?.renderData(
                                                  header,
                                                  row,
                                                  value
                                                ).length > 0
                                              ) {
                                                data.push(
                                                  functions
                                                    ?.renderData(
                                                      header,
                                                      row,
                                                      value
                                                    )
                                                    ?.map((imageUrl, index) => {
                                                      if (
                                                        functions.isExcelDocumentFormatTableView(
                                                          [imageUrl]
                                                        )
                                                      ) {
                                                        return (
                                                          <div className="d-flex justify-content-center">
                                                            <img
                                                              key={index}
                                                              src={
                                                                "/images/icon/excel.svg"
                                                              }
                                                              className="selected-image-list set-img"
                                                              alt=""
                                                              style={{
                                                                width: "32px",
                                                                height: "32px",
                                                              }}
                                                            />
                                                          </div>
                                                        );
                                                      } else if (
                                                        functions.isPdfDocumentFormatTableView(
                                                          [imageUrl]
                                                        )
                                                      ) {
                                                        return (
                                                          <div className="d-flex justify-content-center">
                                                            <img
                                                              key={index}
                                                              src={
                                                                "/images/icon/pdf.svg"
                                                              }
                                                              className="selected-image-list set-img"
                                                              alt=""
                                                              style={{
                                                                width: "32px",
                                                                height: "32px",
                                                              }}
                                                            />
                                                          </div>
                                                        );
                                                      } else if (
                                                        functions.isDocDocumentFormatTableView(
                                                          [imageUrl]
                                                        )
                                                      ) {
                                                        return (
                                                          <div className="d-flex justify-content-center">
                                                            <img
                                                              key={index}
                                                              src={
                                                                "/images/icon/docs.svg"
                                                              }
                                                              className="selected-image-list set-img"
                                                              alt=""
                                                              style={{
                                                                width: "32px",
                                                                height: "32px",
                                                              }}
                                                            />
                                                          </div>
                                                        );
                                                      } else if (
                                                        functions.isZipDocumentFormatTableView(
                                                          [imageUrl]
                                                        )
                                                      ) {
                                                        return (
                                                          <div className="d-flex justify-content-center">
                                                            <img
                                                              key={index}
                                                              src={
                                                                "/images/icon/zip.svg"
                                                              }
                                                              className="selected-image-list set-img"
                                                              alt=""
                                                              style={{
                                                                width: "32px",
                                                                height: "32px",
                                                              }}
                                                            />
                                                          </div>
                                                        );
                                                      } else if (
                                                        functions.isImageDocumentFormatTableView(
                                                          [imageUrl]
                                                        )
                                                      ) {
                                                        if (index == 0) {
                                                          return (
                                                            <div className="d-flex justify-content-center">
                                                              <img
                                                                key={index}
                                                                src={
                                                                  imageUrl
                                                                    ? proxy() +
                                                                      imageUrl
                                                                    : "/images/icon/file-unknown.svg"
                                                                }
                                                                className="selected-image-list set-img"
                                                                alt="#"
                                                              />
                                                            </div>
                                                          );
                                                        }
                                                        return null;
                                                      } else {
                                                        // Nếu không phải là các định dạng đã kiểm tra, bạn có thể hiển thị một biểu tượng mặc định hoặc thực hiện hành động khác tùy thuộc vào yêu cầu của bạn
                                                        return (
                                                          <img
                                                            key={index}
                                                            src={
                                                              "/images/icon/file-unknown.svg"
                                                            }
                                                            className="selected-image-list set-img"
                                                            alt=""
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          />
                                                        );
                                                      }
                                                    })
                                                );
                                              }
                                            } else {
                                              if (
                                                Array.isArray(row[value]) &&
                                                row[value].length > 0 &&
                                                (!condition_fields ||
                                                  condition_fields.length === 0)
                                              ) {
                                                // isArrayData.current =
                                                //   row[value];
                                                const content = [];
                                                for (const index in row[
                                                  value
                                                ]) {
                                                  const _item =
                                                    row[value][index];
                                                  content.push(
                                                    <ul
                                                      // className="ml-4"
                                                      style={
                                                        {
                                                          // listStyleType:
                                                          //   is_data_array &&
                                                          //   _item &&
                                                          //   "unset",
                                                        }
                                                      }
                                                    >
                                                      <li>
                                                        <span>
                                                          {functions.renderData(
                                                            header,
                                                            {
                                                              [value]: _item,
                                                            },
                                                            value,
                                                            proxy,
                                                            redirect_fields,
                                                            handleRedirect,
                                                            handleRedirectTable,
                                                            fontSize,
                                                            color,
                                                            props,
                                                            textDecoration,
                                                            fontWeight,
                                                            background_color
                                                          )}
                                                        </span>
                                                      </li>
                                                    </ul>
                                                  );
                                                }
                                                data.push(
                                                  <Accordion
                                                    children={content}
                                                    title={content?.[0] || ""}
                                                    is_data_array={
                                                      is_data_array
                                                    }
                                                  />
                                                );
                                              } else {
                                                const findItem =
                                                  database.fields.find(
                                                    ({ fomular_alias }) =>
                                                      fomular_alias === alias
                                                  );
                                                data.push(
                                                  <>
                                                    {functions.renderData(
                                                      header || findItem,
                                                      row,
                                                      value,
                                                      proxy,
                                                      redirect_fields,
                                                      handleRedirect,
                                                      handleRedirectTable,
                                                      fontSize,
                                                      color,
                                                      props,
                                                      textDecoration,
                                                      fontWeight,
                                                      background_color
                                                    )}
                                                  </>
                                                );
                                              }
                                            }
                                          }
                                        );
                                      return data;
                                    })()}
                                  </td>
                                );
                              }
                            )}
                            {hasInlineButtons && (
                              <td
                                class="align-center actions"
                                style={{ right: 0, background: "#fff" }}
                              >
                                <RenderInlineButtonsForRow
                                  data={currentData}
                                  children={children}
                                  {...props}
                                  tableProps={tableProps}
                                  row={row}
                                  redirectToInputPUT={redirectToInputPUT}
                                  handleViewDetail={handleViewDetail}
                                  handleDelete={handleDelete}
                                  handleRedirect={handleRedirect}
                                  handleRedirectTable={handleRedirectTable}
                                  dataPrivileges={dataPrivileges}
                                  exportFile={exportFile}
                                  exportFile_PK={exportFile_PK}
                                  submitButton_Custom={submitButton_Custom}
                                  selectAllChecked={selectAllChecked}
                                  privilegesDetail={privilegesDetail}
                                  setRefreshPage={setRefreshPage}
                                  setRow={setRow}
                                  setButtonId={setButtonId}
                                  buttonId={buttonId}
                                />
                              </td>
                            )}
                          </tr>
                          {isAccordionTable[index] && (
                            <tr>
                              <AccordionTable
                                widthRefAccordionTable={
                                  widthRefAccordionTable.current
                                }
                                isAccordionTable={isAccordionTable}
                                _index={index}
                                apiData={row}
                                DisplayFields={DisplayFields}
                                isArrayData={isArrayData.current}
                                setApiData={setApiData}
                                setAccordionTable={setAccordionTable}
                              />
                            </tr>
                          )}
                        </>
                      );
                    } else {
                      return null;
                    }
                  })
                ) : (
                  <tr>
                    <td
                      class="font-weight-bold cell"
                      colspan={`${DisplayFields.length + 2}`}
                      style={{ textAlign: "center" }}
                    >
                      <div>
                        {loadingTable ? (
                          <img
                            width={35}
                            className="mb-1"
                            src="/images/icon/load.gif"
                            alt="Loading..."
                          ></img>
                        ) : isForbidden ? (
                          lang["no privileges"]
                        ) : isCalculating ? (
                          "Đang tính toán lại dữ liệu"
                        ) : (
                          lang["not found"]
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>
        {currentData && currentData.length > 0 && (
          <div
            className="d-flex justify-content-between align-items-center w-100"
            style={{
              marginTop: "1px",
              display: "none",
            }}
          >
            <div className="col-sm-8 p-0">
              <p>
                {/* {lang["show"]} {apiData.length > 0 ? indexOfFirst + 1 : 0}-{Math.min(indexOfLast, apiData.length)} {lang["of"]} {apiData.length} {lang["results"]} */}
                {lang["show"]} {functions.formatNumber(indexOfFirst + 1)} -{" "}
                {functions.formatNumber(indexOfFirst + apiData?.length)}{" "}
                {`${lang["of"]} `}
                {loadingResult ? (
                  <img
                    width={20}
                    className="mb-1"
                    src="/images/icon/load.gif"
                    alt="Loading..."
                  ></img>
                ) : (
                  functions.formatNumber(sumerize)
                )}{" "}
                {lang["results"]}
              </p>
            </div>
            <div className="col-sm-4 p-0">
              <nav aria-label="Page navigation example">
                <ul className="pagination mb-0 justify-content-end">
                  {/* Nút đến trang đầu */}
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => paginate(1, true)}
                    >
                      &#8810;
                    </button>
                  </li>
                  <li
                    className={`page-item ${
                      currentPage === 1 || totalPages === 0 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        paginate(Math.max(1, currentPage - 1), false)
                      }
                    >
                      &laquo;
                    </button>
                  </li>
                  {currentPage > 2 && (
                    <li className="page-item">
                      <span className="page-link">...</span>
                    </li>
                  )}

                  {Array(totalPages)
                    .fill()
                    .map((_, index) => {
                      if (
                        index + 1 === currentPage ||
                        (index + 1 >= currentPage - 1 &&
                          index + 1 <= currentPage + 1)
                      ) {
                        return (
                          <li
                            key={index}
                            className={`page-item ${
                              currentPage === index + 1 ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(index + 1, false)}
                            >
                              {functions.formatNumber(index + 1)}
                            </button>
                          </li>
                        );
                      }
                      return null;
                    })}
                  {currentPage < totalPages - 1 && (
                    <li className="page-item">
                      <span className="page-link">...</span>
                    </li>
                  )}
                  <li
                    className={`page-item ${
                      currentPage === totalPages || totalPages === 0
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        paginate(Math.min(totalPages, currentPage + 1), false)
                      }
                    >
                      &raquo;
                    </button>
                  </li>
                  {/* Nút đến trang cuối */}
                  {/* thinh day la nut phan trang */}
                  <li
                    className={`page-item ${
                      currentPage === totalPages || totalPages === 0
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => paginate(totalPages, true)}
                    >
                      &#8811;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const RenderInlineButtonsForRow = (props) => {
  console.log(420123, props);
  const { lang, proxy, auth, functions, pages, database } = useSelector(
    (state) => state
  );
  const { openTab, renderDateTimeByFormat } = functions;
  const {
    children,
    buttons,
    row,
    handleViewDetail,
    redirectToInputPUT,
    handleRedirect,
    handleRedirectTable,
    handleDelete,
    exportFile,
    exportFile_PK,
    submitButton_Custom,
    dataPrivileges,
    selectAllChecked,
    privilegesDetail,
    setRefreshPage,
    _user,
    setButtonId,
    buttonId,
  } = props;
  const dataTableField = props.props.source.added_fields;
  const orderedKeys = ["approve", "unapprove", "detail", "update", "delete"]; // Thứ tự mong muốn
  const dispatch = useDispatch();
  const { project_id, version_id, id_str, url } = useParams();
  const stringifiedUser = localStorage.getItem("user");
  // const _user = JSON.parse(stringifiedUser) || {};
  const _token = localStorage.getItem("_token");
  const getLockbuttons = props?.props?.lockbuttons;
  const loadingCode = useRef(true);
  const [isModal, setModal] = useState(false);
  const navigate = useNavigate();

  const handleCheckIsDisabledButton = (key) => {
    for (const k in getLockbuttons) {
      if (getLockbuttons?.[k]?.[props.row[k]]?.[key]) {
        return IS_DISABLED_BUTTON;
      }
    }
  };

  // useEffect(() => {
  //   fetch(`${proxy()}/privileges/accounts`, {
  //     headers: {
  //       Authorization: _token,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((resp) => {
  //       const { success, data, activated, status, content } = resp;
  //       if (success && data.length > 0) {
  //         const dataUser = data.find(
  //           (item) => item.username === _user.username
  //         );
  //         setDataPrivileges(dataUser?.privileges);
  //       }
  //     });
  // }, []);

  const dataTable_id = props.props.source.tables[0].id;

  const dataCheckAdministrator = {
    read: true,
    write: true,
    modify: true,
    purge: true,
    redirect_button: true,
    code_generating_button: true,
    table_export_button: true,
    custom_button: true,
  };

  const dataCheck =
    _user?.role !== "uad"
      ? dataPrivileges?.find((item) => item.table_id === dataTable_id)
      : dataCheckAdministrator;
  const handleApprove = async (record, dataApi) => {
    const urlApprove = dataApi.api.url;
    const fomular_approve = dataApi.field.fomular_alias;

    if (urlApprove != undefined) {
      const id_str = urlApprove.split("/")[2];
      const response = await new Promise((resolve, reject) => {
        fetch(`${proxy()}/apis/api/${id_str}/input_info`, {
          headers: {
            Authorization: _token,
          },
        })
          .then((res) => res.json())
          .then((res) => {
            const { data, success, content } = res;
            ////////////////console.log(res)
            if (success) {
            }
            resolve(res);
          });
      });
      const { success, data } = response;
      ////////////////console.log(54, response)
      if (success) {
        const { params } = data;
        const stringifiedParams = params
          .map((param) => {
            const { fomular_alias } = param;
            return record[fomular_alias];
          })
          .join("/");
        ////////////////console.log(962, stringifiedParams)

        const bodyApprove = {
          [fomular_approve]: true,
        };
        ////////////////console.log(bodyApprove)
        fetch(`${proxy()}${urlApprove}/${stringifiedParams}`, {
          method: "PUT",
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
          body: JSON.stringify({ ...bodyApprove }),
        })
          .then((res) => res.json())
          .then((res) => {
            const { success } = res;
            if (success) {
              dispatch({
                branch: "ui",
                type: "checkState",
                payload: {
                  success: true,
                },
              });
              Swal.fire({
                title: lang["success"],
                text: lang["success.update"],
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          })
          .catch((error) => {
            // Xử lý lỗi nếu cần
          });
      }
    } else {
    }
  };

  const handleUnApprove = async (record, dataApi) => {
    const urlUnApprove = dataApi.api.url;
    const fomular_unapprove = dataApi.field.fomular_alias;
    ////////////////console.log(fomular_unapprove)
    if (urlUnApprove != undefined) {
      const id_str = urlUnApprove.split("/")[2];
      const response = await new Promise((resolve, reject) => {
        fetch(`${proxy()}/apis/api/${id_str}/input_info`, {
          headers: {
            Authorization: _token,
          },
        })
          .then((res) => res.json())
          .then((res) => {
            const { data, success, content } = res;
            ////////////////console.log(res)
            if (success) {
            }
            resolve(res);
          });
      });
      const { success, data } = response;
      ////////////////console.log(54, response)
      if (success) {
        const { params } = data;
        const stringifiedParams = params
          .map((param) => {
            const { fomular_alias } = param;
            return record[fomular_alias];
          })
          .join("/");
        ////////////////console.log(962, stringifiedParams)
        const bodyUnApprove = {
          [fomular_unapprove]: false,
        };
        ////////////////console.log(bodyUnApprove)
        fetch(`${proxy()}${urlUnApprove}/${stringifiedParams}`, {
          method: "PUT",
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
          body: JSON.stringify({ ...bodyUnApprove }),
        })
          .then((res) => res.json())
          .then((res) => {
            ////////////////console.log(res)
            if (success) {
              dispatch({
                branch: "ui",
                type: "checkState",
                payload: {
                  success: true,
                },
              });

              Swal.fire({
                title: lang["success"],
                text: lang["success.update"],
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          })
          .catch((error) => {});
      }
    } else {
    }
  };

  // const handleTable_Param = async (row, pageId, params) => {
  //   let params_mapped = "";
  //   const page = pages.find((page) => page.page_id === pageId);

  //   if (page?.old_url_format) {
  //     const fomularAlias = params.map((item) => item.fomular_alias);
  //     const values = fomularAlias.map((alias) => row[alias]);

  //     openTab(`/${pageId}/${values.join("/")}`);
  //   } else {
  //     params?.map(({ fomular_alias }) => {
  //       params_mapped += `${fomular_alias}=${row[fomular_alias]}&`;
  //     });

  //     params_mapped = "?" + params_mapped;
  //     params_mapped = params_mapped.slice(0, -1);
  //     openTab(`/${pageId}${params_mapped}`);
  //   }
  // };

  const handleTableExportButton = async (row, pageId, params) => {
    const fomularAlias = params.map((item) => item.fomular_alias);
    const values = fomularAlias.map((alias) => row[alias]);
    openTab(`/page/${pageId}/${values}`);
  };
  const handleSetModal = () => {
    setModal(true);
  };
  const mappedButtons = (row) =>
    children?.map((child) => {
      const { id, props: buttonProps, name } = child;
      const { to, icon, style, fields, api, preview_api, primary_key, value } =
        buttonProps;
      // console.log("child::", to.params);
      setButtonId(id);

      const { color, backgroundColor } = style;
      const disableIcon = handleCheckIsDisabledButton(id);
      // if(handleCheckIsDisabledButton(id)){
      //   return null
      // }

      const primaryKeys = primary_key?.[0]?.fomular_alias;
      // Tìm trường có id trùng với primary_ke
      const fomular = child?.props?.primary_key?.fomular_alias;

      const table_alias =
        props?.component?.props?.source?.tables?.length > 0 &&
        props?.component?.props?.source?.tables?.[0]?.table_alias;

      const { ct = {} } = auth || {};

      const KEYS = {
        redirect_button: "redirect_button",
        code_generating_button: "code_generating_button",
        table_export_button: "table_export_button",
        custom_button: "custom_button",
        export_files: "export_files",
      };
      const BUTTONS_FROM_DESIGN = props.buttons;

      if (!["pm", "uad"].includes(auth.role)) {
        for (const index in ct || []) {
          const item = ct[index];
          if (item?.cpn_id == props.component.id && !item?.[id]) {
            return null;
          }
        }
      }
      switch (name) {
        case "redirect_button":
          return (
            <>
              <div
                key={id}
                class={`icon-table-line ${disableIcon ? "none-hover" : ""}`}
                style={{ color: color, backgroundColor: backgroundColor }}
                onClick={() => {
                  handleRedirect(
                    row,
                    to.page_id,
                    to.params,
                    "",
                    child.props,
                    "modalRedirect",
                    { buttonId }
                  );
                }}
                data-toggle="modal"
                data-target="#modalRedirect"
              >
                <FontAwesomeIcon
                  icon={icons[icon]?.icon}
                  title={
                    child?.props?.title
                      ? child?.props?.title
                      : lang["redirect_button"]
                  }
                />
              </div>
            </>
          );
        case "code_generating_button":
          return (
            <>
              <button
                key={id}
                class={`icon-table-line ${disableIcon ? "none-hover" : ""}`}
                style={{
                  color: color,
                  backgroundColor: backgroundColor,
                  opacity: disableIcon ? 0.3 : 1,
                }}
                onClick={() => {
                  const {
                    props: {
                      api,
                      field,
                      primary_key,
                      value,
                      generator: {
                        amount,
                        pattern,
                        table,
                        indexField,
                        onField,
                        onOption,
                        prefix,
                        autoIncrement,
                        pattern2,
                      },
                    },
                  } = child;
                  const {
                    props: {
                      source: { DisplayFields },
                    },
                  } = props;

                  const mapped_fields = {};

                  for (const index in DisplayFields) {
                    const { value } = DisplayFields[index];

                    for (const i in value) {
                      const item = value[i];

                      let alias = item.label
                        ?.split("-$")
                        ?.at(-1)
                        ?.split(".")
                        ?.at(-1);

                      alias = alias[0] === "$" ? alias.slice(1) : alias;
                      mapped_fields[alias] = item.value;
                    }
                  }

                  const mapped_row = {};

                  for (const index in dataTableField) {
                    const field = dataTableField[index];

                    if (row?.[mapped_fields[field.fomular_alias]]) {
                      mapped_row[field.fomular_alias] =
                        row[mapped_fields[field.fomular_alias]];
                    }
                  }

                  const payload = {
                    amount: mapped_row[amount.fomular_alias],
                    pattern,
                    prefix,
                    autoIncrement,
                    pattern2,
                    indexField: indexField.id,
                    onField: onField.id,
                    onOption: onOption?.id,
                    table: table.id,
                    foreign_table: props.props.source.tables[0].id,
                    foreign_value:
                      props.row[
                        props.props.source.added_fields.find(
                          (field) =>
                            field.id ===
                            props.props.source.tables[0].primary_key[0]
                        )?.fomular_alias
                      ],
                  };

                  Swal.fire({
                    title: lang["loading"],
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                      Swal.showLoading();
                    },
                  });

                  const params = [];

                  api?.params.map((param) => {
                    const field = dataTableField.find(
                      (item) => item.id === param
                    );
                    if (mapped_row[field?.fomular_alias]) {
                      params.push(mapped_row[field.fomular_alias]);
                    }
                  });

                  const field_updated = {
                    ...value,
                    ...mapped_row,
                  };

                  for (const index in api?.fields) {
                    const field = api.fields[index];
                    field_updated[field.fomular_alias] = field.value;
                  }

                  GenerateRandomCode.create(
                    payload,
                    proxy(),
                    _token,
                    params[0]
                  ).then((res) => {
                    if (res.success) {
                      Tables.update(api.url, params[0], field_updated, proxy())
                        .then((res) => res.json())
                        .then((res) => {
                          if (res.success) {
                            Swal.fire({
                              title: lang["success"],
                              text: lang["success.update"],
                              icon: "success",
                              showConfirmButton: false,
                              timer: 1500,
                            }).then(() => setRefreshPage((prev) => prev + 1));
                          } else {
                            Swal.fire({
                              title: lang["error"],
                              text: "Update failed",
                              icon: "error",
                              showConfirmButton: false,
                              timer: 1500,
                            });
                          }
                        })
                        .catch(() => {
                          Swal.fire({
                            title: lang["error"],
                            text: res.content,
                            icon: "error",
                            showConfirmButton: false,
                            timer: 1500,
                          });
                        });
                    }
                  });
                }}
              >
                <FontAwesomeIcon
                  icon={icons[icon]?.icon}
                  key={name}
                  title={
                    child?.props?.title
                      ? child?.props?.title
                      : lang["code_generating_button"]
                  }
                />
              </button>
            </>
          );
        case "table_export_button":
          return (
            <>
              <div
                key={id}
                class={`icon-table-line ${disableIcon ? "none-hover" : ""}`}
                style={{ color: color, backgroundColor: backgroundColor }}
                onClick={() =>
                  exportFile_PK(
                    preview_api.DisplayFields,
                    preview_api.url,
                    api.url,
                    fomular,
                    row,
                    fields
                  )
                }
                data-toggle="modal"
                data-target="#exportExcel_PK"
              >
                <FontAwesomeIcon
                  icon={icons[icon]?.icon}
                  title={
                    child?.props?.title
                      ? child?.props?.title
                      : lang["table_export_button"]
                  }
                />
              </div>
            </>
          );
        case "custom_button":
          const {
            props: {
              source: { display_fields, DisplayFields, added_fields },
            },
          } = props;
          const {
            props: { isConfirm, labelConfirm },
          } = child;
          const mapped_fields = {};
          for (const index in DisplayFields) {
            const { value } = DisplayFields[index];

            for (const i in value) {
              const item = value[i];

              let alias = item.label?.split("-$")?.at(-1)?.split(".")?.at(-1);

              alias = alias[0] === "$" ? alias.slice(1) : alias;
              mapped_fields[alias] = item.value;
            }
          }
          const mapped_row = {};

          for (const index in database.fields) {
            const field = database.fields[index];

            if (row?.[mapped_fields[field.fomular_alias]]) {
              mapped_row[field.fomular_alias] =
                row[mapped_fields[field.fomular_alias]];
            }
          }

          return (
            <>
              <div
                key={id}
                class={`icon-table-line ${disableIcon ? "none-hover" : ""}`}
                style={{
                  color: color,
                  backgroundColor: backgroundColor,
                  opacity: disableIcon ? 0.3 : 1,
                }}
                onClick={() => {
                  if (isConfirm) {
                    Swal.fire({
                      title: lang["confirm"],
                      text: labelConfirm,
                      icon: "info",
                      showCancelButton: true,
                      confirmButtonText: lang["btn.browse"],
                      cancelButtonText: lang["btn.cancel"],
                      confirmButtonColor: "rgb(209, 72, 81)",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        submitButton_Custom(
                          api.params,
                          api.url,
                          child.props.condition_fields,
                          child.props.fields,
                          mapped_row,
                          dataTableField,
                          props,
                          { refreshCustom: setRefreshPage }
                        );
                      }
                    });
                  } else {
                    submitButton_Custom(
                      api.params,
                      api.url,
                      child.props.condition_fields,
                      child.props.fields,
                      mapped_row,
                      dataTableField,
                      props,
                      { refreshCustom: setRefreshPage }
                    );
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={icons[icon]?.icon}
                  title={
                    child?.props?.title
                      ? child?.props?.title
                      : lang["custom_button"]
                  }
                />
                {/* <i className="fa fa fa-list-ul size-24 mr-1  pointer icon-list" key={id} onClick={() => exportFile_PK(fields, preview_api.url, api.url, fomular, row)} data-toggle="modal" data-target="#exportExcel_PK" title={lang["viewdetail"]}></i> */}
              </div>
            </>
          );
        case "export_files":
          const {
            props: { type, pageDesign, html },
          } = child;

          const components = {
            PhieuXuatKho: PhieuXuatKho,
            PhieuNhapKhoPDF: PhieuNhapKhoPDF,
            LenhGiaoHang: LenhGiaoHang,
            LenhSanXuat: PopupImagesList,
            PhieuNhapKhoKCS: PhieuNhapKhoKCS,
            UpdatePhieuNhapKho: UpdatePhieuNhapKho,
            UpdatePhieuXuatKho: UpdatePhieuXuatKho,
            ModalSoanHangPhieuXuatKho: ModalSoanHangPhieuXuatKho,
          };
          const Component = components[pageDesign];

          switch (type.toLowerCase()) {
            case "pdf":
            case "files":
              return (
                <div
                  key={id}
                  className={`icon-table-line ${
                    disableIcon ? "none-hover" : ""
                  }`}
                  style={{ color, backgroundColor }}
                >
                  {Component && (
                    <Component
                      {...props}
                      item={child.props}
                      icons={icons}
                      icon={icon}
                      data={row}
                      html={html}
                    />
                  )}
                </div>
              );
            case "layout":
              return (
                <div
                  key={id}
                  className={`icon-table-line ${
                    disableIcon ||
                    (pageDesign === "UpdatePhieuXuatKho" &&
                      row?.TrangThaiSoanHang !== "TT040")
                      ? "none-hover"
                      : ""
                  }`}
                  style={{
                    color,
                    backgroundColor,
                    opacity:
                      disableIcon ||
                      (pageDesign === "UpdatePhieuXuatKho" &&
                        row?.TrangThaiSoanHang !== "TT040")
                        ? 0.3
                        : 1,
                  }}
                >
                  {Component && (
                    <Component
                      {...props}
                      item={child.props}
                      icons={icons}
                      icon={icon}
                      data={row}
                      html={html}
                    />
                  )}
                </div>
              );
          }
        default:
      }
    });

  // mappedButtons sẽ là một mảng các phần tử JSX của nút
  const fomularAlias = props.buttons.approve.field.fomular_alias;
  const shouldHideIconApprove = (row) => {
    // Kiểm tra điều kiện và trả về true nếu cần ẩn icon
    return fomularAlias && row[fomularAlias] === true;
  };

  const shouldHideIconUnApprove = (row) => {
    // Kiểm tra điều kiện và trả về true nếu cần ẩn icon
    return fomularAlias && row[fomularAlias] === false;
  };

  return (
    <div class="icon-table">
      {orderedKeys
        .filter(
          (key) =>
            buttons[key] && buttons[key].state && buttons[key].api !== null
        )
        .map((key) => {
          const { ct = {} } = auth || {};

          const KEYS = {
            approve: "approve",
            unapprove: "unapprove",
            detail: "detail",
            update: "update",
            delete: "delete",
          };
          const BUTTONS_FROM_DESIGN = props.buttons;
          if (!BUTTONS_FROM_DESIGN[key]) {
            return null;
          }
          if (!["pm", "uad"].includes(auth.role)) {
            for (const index in ct || []) {
              const item = ct[index];
              if (item?.cpn_id === props.component.id && !item?.[KEYS[key]]) {
                return null;
              }
            }
          }
          const disableIcon = handleCheckIsDisabledButton(key);
          switch (key) {
            case "approve":
              return !handleCheckIsDisabledButton("approve") ? (
                <div class="icon-table-line">
                  {shouldHideIconApprove(row) ? (
                    <i
                      className="fa fa-check-circle-o size-24 pointer icon-check icon-disable"
                      key={key}
                    ></i>
                  ) : (
                    <i
                      className="fa fa-check-circle-o size-24 pointer icon-check"
                      onClick={() => handleApprove(row, props.buttons.approve)}
                      title={lang["updatestatus"]}
                    ></i>
                  )}
                </div>
              ) : null;
            case "unapprove":
              return !handleCheckIsDisabledButton("unapprove") ? (
                <div className="icon-table-line">
                  {shouldHideIconUnApprove(row) ? (
                    <i
                      className="fa fa-times-circle-o size-24 pointer icon-close icon-disable"
                      key={key}
                    ></i>
                  ) : (
                    <i
                      className="fa fa-times-circle-o size-24 pointer icon-close"
                      key={key}
                      onClick={() =>
                        handleUnApprove(row, props.buttons.unapprove)
                      }
                      title={lang["updatestatus"]}
                    ></i>
                  )}
                </div>
              ) : null;
            case "detail":
              return (
                <>
                  <div
                    key={key}
                    className={`icon-table-line ${
                      disableIcon ? "none-hover" : ""
                    }`}
                    style={{
                      opacity: disableIcon ? 0.5 : 1,
                    }}
                    // class={`icon-table-line ${disableIcon ? "none-hover" : ""}`}
                    onClick={() =>
                      handleViewDetail(row, props.buttons.detail.api.url, props)
                    }
                    data-toggle="modal"
                    data-target="#modalDetail"
                  >
                    <FontAwesomeIcon
                      icon={faEye}
                      title={lang["viewdetail"]}
                      className="size-20 mr-1 pointer icon-view"
                    />
                  </div>
                </>
              );
            case "update":
              return (
                <>
                  <div
                    key={key}
                    className={`icon-table-line ${
                      disableIcon ? "none-hover" : ""
                    }`}
                    style={{
                      opacity: disableIcon ? 0.5 : 1,
                    }}
                    onClick={() => {
                      if (props.buttons.update.CustomUrl) {
                        const primaryKey =
                          props?.tableProps?.source?.tables?.[0]
                            .primary_key?.[0];
                        const fields =
                          props?.tableProps?.source?.tables?.[0].fields;
                        const field = fields.find((f) => f.id === primaryKey);
                        navigate(
                          `${props.buttons.update.CustomUrl}/${
                            row[field.fomular_alias]
                          }`
                        );
                      } else {
                        redirectToInputPUT(
                          row,
                          props,
                          props.buttons.update.api.url,
                          setRefreshPage
                        );
                      }
                    }}
                    data-toggle="modal"
                    data-target="#modalEdit"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      title={lang["edit"]}
                      className="fa fa-edit size-20 pointer icon-edit"
                    />
                  </div>
                </>
              );
            case "delete":
              console.log("HIPORPSSS", props.buttons);
              return (
                <div
                  className={`icon-table-line ${
                    disableIcon ? "none-hover" : ""
                  }`}
                  style={{
                    opacity: disableIcon ? 0.5 : 1,
                  }}
                  key={key}
                  onClick={() =>
                    handleDelete(row, setRefreshPage, props.buttons.delete)
                  }
                >
                  <FontAwesomeIcon
                    icon={faTrashCan}
                    className="size-20 pointer icon-delete"
                    title={lang["delete"]}
                  />
                </div>
              );
            default:
              return <button key={key}>{key}</button>;
          }
        })}

      {mappedButtons(row)}
    </div>
  );
};

const RenderChart = (props, { extraButtons }) => {
  const { _user, dataPrivileges, handleRefreshPage } = props;
  console.log(730, props.props);

  const url = props?.props?.api;
  const paramsSearch = props.props.params;

  const { lang, proxy, auth, functions } = useSelector((state) => state);
  const _token = localStorage.getItem("_token");

  const [apiDataStatis, setApiDataStatis] = useState([]);

  const [field, setField] = useState({});
  const [height, setHeight] = useState(350);
  const widthChart = useRef(null);
  useEffect(() => {
    if (props.criteria?.charts?.includes(props.chart_id)) {
      callApiStatistic(props.criteria.data);
    }
  }, [props.criteria]);

  useEffect(() => {
    callApiStatistic();
  }, [paramsSearch]); // Chỉ gọi API khi paramsSearch thay đổi

  ///search data
  const [parentFormData, setParentFormData] = useState({});
  const handleFormDataChange = (newFormData) => {
    setParentFormData(newFormData);
  };

  const handleSubmitSearch = (newFormData) => {
    callApiStatistic(newFormData);
  };

  const handleResetSearchValue = (newFormData) => {
    ////////console.log(1137, newFormData)
    setParentFormData({});
    callApiStatistic({});
  };

  const [loadingDataChart, setLoadingDataChart] = useState(false);

  const callApiStatistic = (formData = parentFormData) => {
    setLoadingDataChart(true);
    const statisBody = {
      criterias: formData,
    };

    fetch(`${proxy()}${url.url}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: _token,
      },
      body: JSON.stringify(statisBody),
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, content, data: statistics, fields, field } = res;
        const { CHART_TYPES, new_charts } = props.props;

        if (success && statistics.length) {
          const charts_mapped = [];

          for (let i = 0; i < new_charts?.length; i++) {
            const series = [];
            const categories = [];
            const chart = new_charts[i];

            for (let j = 0; j < chart?.sections?.length; j++) {
              const { section } = chart?.sections[j];
              const { keys, values } = section;

              if (keys?.value?.startsWith("$")) {
                let splitValue = "";
                if (typeof keys.value === "string") {
                  splitValue = keys.value.split("$")[1];
                }

                if (splitValue) {
                  statistics &&
                    statistics.length &&
                    statistics.filter((item) => {
                      if (item[splitValue] !== undefined) {
                        if (IsDate(item[splitValue])) {
                          categories.push(
                            new Date(item[splitValue]).toLocaleDateString() || 0
                          );
                        } else {
                          if (
                            chart?.type === "HorizontalLineChart" ||
                            chart?.type === "VerticalLineChartManyData"
                          ) {
                            categories.push(item[splitValue] || "0");
                          } else {
                            categories.push(splitValue || "0");
                          }
                        }
                      }
                    });
                }
              } else {
                if (IsDate(keys?.value)) {
                  categories.push(new Date(keys.value).toString());
                } else {
                  categories.push(keys.value || "0");
                }
              }

              const seriesData = values?.map(({ value }) => {
                let splitValue = "";
                if (typeof value?.value === "string") {
                  splitValue = value?.value.split("$")[1];
                }
                if (splitValue) {
                  let data = [];
                  statistics?.filter((item) => {
                    if (
                      item[splitValue] !== undefined &&
                      item[splitValue] !== null
                    ) {
                      if (IsDate(item[splitValue])) {
                        data.push(new Date(item[splitValue]).toDateString());
                      } else {
                        data.push(item[splitValue] || 0);
                      }
                    }
                  });

                  const CircleChart = "CircleChart";
                  if (
                    data?.length < categories.length &&
                    chart?.type !== CircleChart
                  ) {
                    const newData = [];
                    for (
                      let ii = 0;
                      ii < categories.length - data.length;
                      ii++
                    ) {
                      newData.push(null);
                    }
                    data = [...newData, ...data];
                  }
                  return {
                    name: splitValue,
                    data,
                  };
                }
              });
              series.push(...(seriesData || []));
            }
            charts_mapped.push({
              type: chart?.type,
              series,
              categories,
              typeData: chart?.typeData,
              colors: chart?.colors,
              position: chart?.position,
            });
          }
          setApiDataStatis(charts_mapped);
          setLoadingDataChart(false);
        } else {
          setLoadingDataChart(true);
        }
      })
      .finally(() => {
        setLoadingDataChart(false);
      });
  };

  const transformDataForChart = (apiData, type) => {
    let {
      categories = [],
      series = [],
      typeData = "",
      colors = [],
      position = "",
    } = apiData;
    if (!apiData || apiData.length || !categories.length || !series.length) {
      return { series: [], options: {} };
    }

    switch (type) {
      case "HorizontalLineChart":
        const height = [];
        series.map((item) => {
          height.push(...item.data);
        });
        let datalength = null;
        let total = series[0].data.map((_, idx) =>
          series.reduce((sum, curr) => sum + curr.data[idx], 0)
        );
        series = series.map((serie) => {
          datalength = serie.data.length;
          const transformedData = serie.data.map((item, index) => {
            if (typeData === "percent") {
              const percent = ((item / total[index]) * 100).toFixed(2);
              return percent + "%";
            }
            return item;
          });
          return {
            ...serie,
            data: transformedData,
          };
        });

        return {
          series,
          options: {
            chart: {
              type: "bar",
              height: 100,
            },
            plotOptions: {
              bar: {
                horizontal: true,
                dataLabels: {
                  position: "top",
                },
              },
            },
            dataLabels: {
              offsetX: 0,
              enabled: true,
              textAnchor: "start",
              style: {
                fontSize: "14px",
                colors: ["#58718a"],
                fontFamily: "UTM Avo, sans-serif",
              },
              formatter: function (val) {
                if (typeData !== "percent") {
                  const formatNum = new Intl.NumberFormat("vn-VN").format(val);
                  return formatNum;
                } else {
                  return isNaN(val) ? 0 : val + "%";
                }
              },
            },
            stroke: {
              show: true,
              width: 1,
              colors: ["#fff"],
            },
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: function (val) {
                  const formatNum = new Intl.NumberFormat("vn-VN").format(val);
                  if (typeData === "percent") {
                    return isNaN(val) ? 0 : val + "%";
                  }
                  return formatNum;
                },
              },
            },
            xaxis: {
              categories,
              labels: {
                style: {
                  fontFamily: "UTM Avo, sans-serif",
                },
              },
            },
            yaxis: {
              labels: {
                style: {
                  fontSize: "12px",
                  fontFamily: "UTM Avo, sans-serif",
                },
              },
            },
            legend: {
              fontSize: "14px",
              fontFamily: "UTM Avo, sans-serif",
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    fontSize: "14px",
                  },
                },
              },
            ],
          },
          height: 50 * height.length,
          style: {
            // display: "flex",
            // "justify-content": "center",
          },
        };
      case "VerticalLineChartSingleData":
        return {
          series,
          options: {
            chart: {
              type: "bar",
              height: 100,
              width: 100,
              toolbar: {
                show: true,
              },
              stacked: true,
            },
            tooltip: {
              hideEmptySeries: true,
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: 60,
                endingShape: "rounded",
                dataLabels: {
                  total: {
                    enabled: typeData === "percent" ? true : false,
                    formatter: function (val, w) {
                      const totaldata = w.config.series.reduce((sum, serie) => {
                        const serieTotal =
                          serie?.data?.reduce((sum, curr) => sum + curr, 0) ||
                          0;
                        return sum + serieTotal;
                      }, 0);
                      const percent = (val / totaldata) * 100;
                      return percent > 0 ? percent.toFixed(2) + "%" : "";
                    },
                  },
                },
              },
            },
            dataLabels: {
              enabled: true,
              style: {
                fontSize: "14px",
                colors: ["#fff"],
                fontFamily: "UTM Avo, sans-serif",
              },
              formatter: function (val) {
                if (typeData !== "percent") {
                  const formatNum = new Intl.NumberFormat("vn-VN").format(val);
                  return formatNum;
                } else {
                  return val + "%";
                }
              },
            },
            stroke: {
              show: true,
              width: 2,
              colors: ["transparent"],
            },
            xaxis: {
              categories,
              labels: {
                style: {
                  fontFamily: "UTM Avo, sans-serif",
                },
                formatter: (value) => {
                  let pairs = [];
                  if (typeof value === "string") {
                    let len = value.split(" ");
                    for (let i = 0; i < len.length; i += 4) {
                      let chunk = len.slice(i, i + 4).join(" ");
                      pairs.push(chunk);
                    }
                    return pairs ? pairs : value;
                  }
                },
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  if (typeData === "percent") {
                    return val + "%";
                  }
                  return val;
                },
              },
            },
            yaxis: {
              labels: {
                style: {
                  fontSize: "12px",
                  fontFamily: "UTM Avo, sans-serif",
                },
              },
            },
            fill: {
              opacity: 1,
            },
            legend: {
              fontSize: "14px",
              fontFamily: "UTM Avo, sans-serif",
              position: position ? position : "bottom",
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  plotOptions: {
                    bar: {
                      columnWidth: 25,
                    },
                  },
                  dataLabels: {
                    textAnchor: "middle",
                    style: {
                      fontSize: "11px",
                    },
                  },
                  legend: {
                    fontSize: "14px",
                  },
                },
              },
            ],
          },
          height: 300,
        };
      case "VerticalLineChartManyData":
        let datalengthManyData = null;
        let totalManyData = series[0].data.map((_, idx) =>
          series.reduce((sum, curr) => sum + curr.data[idx], 0)
        );
        series = series.map((serie) => {
          datalengthManyData = serie.data.length;
          const transformedData = serie.data.map((item, index) => {
            if (typeData === "percent") {
              const percent = ((item / totalManyData[index]) * 100).toFixed(2);
              return percent + "%";
            }
            return item;
          });
          return {
            ...serie,
            data: transformedData,
          };
        });
        return {
          series,
          options: {
            chart: {
              type: "bar",
              height: 100,
              width: 100,
              stackType: "100%",
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: datalengthManyData > 2 ? "50%" : "20%",
                endingShape: "rounded",
                // distributed: true,
                dataLabels: {
                  total: {
                    enabled: true,
                  },
                },
              },
            },
            dataLabels: {
              enabled: true,
              style: {
                // fontSize: "14px",
                colors: ["#58718a"],
                fontFamily: "UTM Avo, sans-serif",
              },
              formatter: function (val) {
                if (typeData !== "percent") {
                  const formatNum = new Intl.NumberFormat("vn-VN").format(val);
                  return formatNum;
                } else {
                  return val + "%";
                }
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  const formatNum = new Intl.NumberFormat("vn-VN").format(val);
                  if (typeData === "percent") {
                    return val + "%";
                  }
                  return formatNum;
                },
              },
            },
            stroke: {
              show: true,
              width: 2,
              colors: ["transparent"],
            },
            xaxis: {
              categories,
              labels: {
                style: {
                  fontFamily: "UTM Avo, sans-serif",
                },
                formatter: (value) => {
                  let pairs = [];
                  if (typeof value === "string") {
                    let len = value.split(" ");
                    for (let i = 0; i < len.length; i += 4) {
                      let chunk = len.slice(i, i + 4).join(" ");
                      pairs.push(chunk);
                    }
                    return pairs ? pairs : value;
                  }
                },
              },
            },
            yaxis: {
              labels: {
                style: {
                  fontSize: "12px",
                  fontFamily: "UTM Avo, sans-serif",
                },
              },
            },
            fill: {
              opacity: 1,
            },
            legend: {
              fontSize: "14px",
              fontFamily: "UTM Avo, sans-serif",
              position: position ? position : "bottom",
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  plotOptions: {
                    bar: {
                      columnWidth: 20,
                    },
                  },
                  dataLabels: {
                    textAnchor: "middle",
                    style: {
                      fontSize: "11px",
                    },
                  },
                  legend: {
                    fontSize: "14px",
                  },
                },
              },
            ],
          },
          height: 300,
        };
      case "CircleChart":
        const newSeries = [];
        const labels = [];
        series.map((item) => {
          if (item?.data) {
            if (Array.isArray(item.data) && item.data.length > 0) {
              newSeries.push(
                ...[Number(item?.data?.[0]?.toString().split(" ")?.[0])]
              );
            }
            labels.push(...item?.data);
            // newSeries.push(...item?.data);
          }
        });
        // console.log("newSeries", newSeries)
        return {
          series: newSeries,
          options: {
            chart: {
              width: 480,
              type: "pie",
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return "";
                },
                title: {
                  formatter: function (val, opts) {
                    const total = opts.w.globals.series.reduce(
                      (acc, val) => acc + val,
                      0
                    );
                    const percent =
                      (opts.w.globals.series[opts.seriesIndex] / total) * 100;

                    if (typeData !== "percent") {
                      const formatNum = new Intl.NumberFormat("vn-VN").format(
                        opts.w.config.series[opts.seriesIndex]
                      );
                      return val + ": " + formatNum;
                    } else {
                      if (isNaN(val)) {
                        return val + ": " + percent.toFixed(2) + "%";
                      }
                    }
                  },
                },
              },
            },
            dataLabels: {
              formatter: function (val, opts) {
                if (typeData !== "percent") {
                  const formatNum = new Intl.NumberFormat("vn-VN").format(
                    opts.w.config.series[opts.seriesIndex]
                  );
                  return formatNum;
                } else {
                  if (!isNaN(val)) {
                    return val.toFixed(2) + "%";
                  }
                }
              },
            },
            labels: categories,
            colors:
              colors.length > 0
                ? colors
                : [
                    "#feb019",
                    "#00e396",
                    "#008ffb",
                    "#FF4560",
                    "#775DD0",
                    "#546E7A",
                    "#662E9B",
                    "#33b2df",
                    "#d4526e",
                    "#13d8aa",
                    "#A5978B",
                    "#2b908f",
                    "#f9a3a4",
                    "#90ee7e",
                    "#f48024",
                    "#69d2e7",
                  ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 400,
                  },
                  legend: {
                    position: "bottom",
                    fontSize: "14px",
                    fontFamily: "UTM Avo, sans-serif",
                  },
                },
              },
              {
                breakpoint: 2561,
                options: {
                  chart: {
                    width: 700,
                  },
                  legend: {
                    position: "right",
                  },
                  dataLabels: {
                    enabled: true,
                  },
                },
              },
              {
                breakpoint: 2000,
                options: {
                  chart: {
                    width: position ? 430 : 580,
                  },
                  legend: {
                    position: position ? position : "right",
                  },
                },
              },
              {
                breakpoint: 1024,
                options: {
                  chart: {
                    width: 450,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
              {
                breakpoint: 769,
                options: {
                  chart: {
                    width: 430,
                  },
                },
              },
            ],
            legend: {
              position: "bottom",
              fontSize: "14px",
              fontFamily: "UTM Avo, sans-serif !important",
              horizontalAlign: "left",

              formatter: function (seriesName, opts) {
                const formatNum = new Intl.NumberFormat("vn-VN").format(
                  opts.w.globals.series[opts.seriesIndex] || 0
                );
                const total = opts.w.globals.series.reduce(
                  (acc, val) => acc + val,
                  0
                );
                const percent =
                  (opts.w.globals.series[opts.seriesIndex] / total) * 100;
                let strimSeries = seriesName.trim();
                const strimArray = strimSeries.split(" ");
                // strimArray.splice(6, 0, "<br>");
                //here
                const updatedStrimSeries = strimArray.join(" ");
                const value = labels?.[opts?.seriesIndex] ?? "";

                if (typeData !== "percent") {
                  return (
                    "<div>" +
                    updatedStrimSeries +
                    ": " +
                    "<span>" +
                    value +
                    "</span>" +
                    "</div>"
                  );
                }
                return (
                  "<div>" +
                  updatedStrimSeries +
                  "<span>" +
                  " " +
                  value +
                  // "%" +
                  "</span>" +
                  "</div>"
                );
              },
            },
          },
        };
      default:
        return { series: [], options: {} };
    }
  };

  return (
    <div
      className="card charts"
      style={{
        borderRadius: ".25rem",
        // boxShadow: "0 0 1px rgba(0,0,0,.125),0 1px 3px rgba(0,0,0,.2)",
      }}
    >
      <div
        className="card-header d-flex justify-content-end align-items-center title"
        style={{ padding: "10px 8px" }}
      >
        {props?.props?.content ? (
          <div style={{ fontStyle: "bold", width: "100%" }}>
            <h5>{props.props.content}</h5>
          </div>
        ) : (
          field &&
          field.length > 0 && (
            <div style={{ fontStyle: "bold", width: "100%" }}>
              <h5>{field?.[0].field_name}</h5>
            </div>
          )
        )}
        <FontAwesomeIcon
          icon={faRetweet}
          onClick={handleRefreshPage}
          className="icon-add pointer mr-3"
          title={lang["Refesh"]}
          style={{ fontSize: "27px", color: "#e0762a" }}
        />
        <div>
          {props?.extraButtons?.props?.buttons?.export?.state === true && (
            <>{props.extraButtons} </>
          )}
        </div>
      </div>
      <div
        ref={widthChart}
        className="apexchart"
        style={{ height: "400px", overflow: "auto" }}
      >
        {loadingDataChart ? (
          <>
            <img
              width={40}
              className="loading-image"
              src="/images/icon/load.gif"
              alt="Loading..."
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}
            />
          </>
        ) : (
          apiDataStatis?.map(({ type, ...data }) => {
            const chartData = transformDataForChart(data, type);
            return (
              <ReactApexChart
                {...chartData}
                type={CHART_TYPE[type]}
                style={{ display: "flex", justifyContent: "center" }}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

const RenderStatisBlock = (props) => {
  ////console.log(730, props.props)
  const dataStatis = props.props;
  const url = props?.props[0].props?.api?.url;

  const { lang, proxy, auth, functions } = useSelector((state) => state);
  const _token = localStorage.getItem("_token");
  const [apiDataStatis, setApiDataStatis] = useState([]);
  const [height, setHeight] = useState(350);

  // useEffect(() => {
  //     callApiStatistic()
  // }, []);

  useEffect(() => {
    // Tạo một mảng promises từ mảng dataStatis
    const promises = dataStatis.map((item) => {
      return callApiStatistic(
        item.props.api?.url,
        item.props?.icon,
        item.props?.label
      );
    });

    // Sử dụng Promise.all để đợi tất cả promises hoàn thành
    Promise.all(promises).then((results) => {
      // Kết quả là một mảng các giá trị được trả về từ từng lời gọi API
      // Cập nhật trạng thái với mảng kết quả này để đảm bảo thứ tự
      setApiDataStatis(results);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const callApiStatistic = (url, icon, label) => {
    // Trả về một promise từ fetch
    return fetch(`${proxy()}${url}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: _token,
      },
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, content, statistics } = res;
        //console.log(1469, res)
        if (success) {
          // Trả về đối tượng dữ liệu cho từng phần tử
          return { icon, label, statistics };
        } else {
          // Trả về một giá trị mặc định hoặc thông báo lỗi
          return { icon, label, statistics: "Error" };
        }
      })
      .catch((error) => {
        // Xử lý lỗi tại đây
        console.error("Error fetching statistics:", error);
        return { icon, label, statistics: "Error" };
      });
  };

  return (
    <div class="statistic-container">
      {apiDataStatis.map((item, index) => (
        <div key={index}>
          <span class="statistic-title">
            <FontAwesomeIcon icon={icons[item?.icon]?.icon} className="mr-1" />
            {item.label}
          </span>

          {Object.keys(item.statistics).length > 0 ? (
            Object.entries(item.statistics).map(
              ([key, value], statIndex, array) => (
                <span class="statistic-value" key={key}>
                  {value}
                  {statIndex < array.length - 1 ? "," : ""}
                </span>
              )
            )
          ) : (
            <span class="statistic-value">0</span>
          )}
        </div>
      ))}
    </div>
  );
};

export const DynamicForm = ({
  props,
  data = [],
  onFormDataChange,
  onFormSubmit,
  onFormReset,
  extraButtons,
  setRefreshPage,
}) => {
  const { lang, proxy, auth, functions, pages } = useSelector((state) => state);
  const { Selected_Fields } = props;

  const [formData, setFormData] = useState({});
  const [isCollapse, setIsCollapse] = useState(false);
  const [refreshSearch, setRefreshSearch] = useState(0);
  const criteria = useRef({});

  const handleCollapse = () => {
    setIsCollapse(!isCollapse);
  };

  const handleInputChange = (fields, value, props, dateType) => {
    let processedValue;

    if (value === "true") {
      processedValue = true;
    } else if (value === "false") {
      processedValue = false;
    } else {
      processedValue = value;
    }

    const newFormData = { ...formData };
    for (const index in fields) {
      const {
        field: { field, key, value: alias },
      } = fields[index];
      if (!criteria.current[key]) {
        criteria.current[key] = {};
      }
      if (!newFormData[key]) {
        newFormData[key] = {};
      }
      criteria.current[key][alias] = processedValue;
      newFormData[key][alias] = processedValue;
    }
    setFormData(newFormData);
    onFormDataChange(newFormData);
  };

  const handleDateFormat = (fieldAlias, value) => {
    const newFormData = { ...formData, [fieldAlias]: value };
    if (!newFormData[fieldAlias]["to"] && !newFormData[fieldAlias]["from"]) {
      delete newFormData[fieldAlias];
    }
    setFormData(newFormData);
    onFormDataChange(newFormData);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onFormSubmit(criteria.current);
  };

  const handleResetSearchValue = (event) => {
    setRefreshSearch((prev) => prev + 1);
    event.preventDefault();
    const newFormData = {};
    setFormData(newFormData);
    onFormDataChange(newFormData);
    onFormReset(newFormData);
  };

  const renderInput = (
    field = {},
    { isMulti, reference_field, search_type, fields, ...props },
    dateType,
    key
  ) => {
    const inputValue = formData?.[key]?.[field?.fomular_alias] || "";

    if (reference_field) {
      const _field = reference_field.field;
      return (
        <Option
          key={refreshSearch}
          label={""}
          onChange={(data) => {
            handleInputChange(
              fields,
              data?.filter(({ value }) => value).map(({ value }) => value),
              props
            );
          }}
          field={_field}
          isMulti={isMulti}
          search_type={search_type}
          primary_key={_field?.id}
          table_id={_field?.table_id}
        />
      );
    }
    if (dateType === "Month" || dateType === "Year") {
      return dateType === "Month" ? (
        <section className="d-flex date">
          <div className="input-search col-md-4 pl-0 d-flex align-items-center">
            <label htmlFor={field.field_name} style={{ width: "25%" }}>
              Tháng bắt đầu:
            </label>
            <span style={{ width: "70%" }}>
              <input
                key={refreshSearch}
                className="form-control"
                type="month"
                onChange={({ target: { value } }) => {
                  const [year, month] = value.split("-");
                  const dateObj = new Date(year, month, 0);
                  const monthTo = dateObj.getUTCMonth() + 1;
                  const day = dateObj.getDate();
                  const yearTo = dateObj.getUTCFullYear();

                  let payload = {
                    from: `${value}-01`,
                    to: inputValue?.to || `${yearTo}-${monthTo}-${day}`,
                  };

                  handleInputChange(fields, payload, props, dateType);
                }}
              />
            </span>
          </div>
          <div className="input-search col-md-4 pl-0 d-flex align-items-center">
            <label style={{ width: "25%" }}>Tháng kết thúc:</label>
            <span style={{ width: "70%" }}>
              <input
                key={refreshSearch}
                className="form-control"
                type="month"
                onChange={({ target: { value } }) => {
                  const [year, month] = value.split("-");
                  const dateObj = new Date(year, month, 0);
                  const day = dateObj.getDate();

                  let payload = {
                    from: inputValue?.from || `${value}-01`,
                    to: `${year}-${month}-${day}`,
                  };

                  handleInputChange(fields, payload, props, dateType);
                }}
              />
            </span>
          </div>
        </section>
      ) : (
        <div className="d-flex">
          <div className="input-search col-md-4 pl-0 d-flex align-items-center">
            <label style={{ width: "25%" }}>Năm bắt đầu</label>
            <span style={{ width: "70%" }}>
              <Select
                key={refreshSearch}
                styles={{
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                options={(() => {
                  const currentYear = new Date().getFullYear();
                  const startYear = currentYear - 30;
                  const options = [];

                  for (let year = currentYear; year >= startYear; year--) {
                    options.push({
                      label: year,
                      value: year,
                    });
                  }
                  return options;
                })()}
                placeholder={lang["select year"]}
                onChange={({ value }) => {
                  let payload = {
                    from: `${value}-01-01`,
                    to: inputValue?.to || `${value}-12-31`,
                  };

                  handleInputChange(fields, payload, props, dateType);
                }}
              />
            </span>
          </div>
          <div className="input-search col-md-4 pl-0 d-flex align-items-center">
            <label style={{ width: "25%" }}>Năm kết thúc</label>
            <span style={{ width: "70%" }}>
              <Select
                key={refreshSearch}
                styles={{
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                options={(() => {
                  const currentYear = new Date().getFullYear();
                  const startYear = currentYear - 30;
                  const options = [];

                  for (let year = currentYear; year >= startYear; year--) {
                    options.push({
                      label: year,
                      value: year,
                    });
                  }
                  return options;
                })()}
                placeholder={lang["select year"]}
                onChange={({ value }) => {
                  let payload = {
                    from: inputValue?.from || `${value}-01-01`,
                    to: `${value}-12-31`,
                  };

                  handleInputChange(fields, payload, props, dateType);
                }}
              />
            </span>
          </div>
        </div>
      );
    }
    const valueBool = [
      {
        id: 0,
        label: field?.DEFAULT_TRUE,
        value: true,
      },
      {
        id: 1,
        label: field?.DEFAULT_FALSE,
        value: false,
      },
    ];

    switch (field?.DATATYPE) {
      case "TEXT":
        return (
          <input
            key={refreshSearch}
            type="text"
            className="form-control"
            placeholder={field.field_name}
            name={field.field_name}
            value={inputValue}
            onChange={(e) => handleInputChange(fields, e.target.value, props)}
          />
        );
      case "INT UNSIGNED" || "BIG INT" || "INT UNSIGNED" || "BIG INT UNSIGNED":
        return (
          <input
            key={refreshSearch}
            type={`${field.AUTO_INCREMENT ? "text" : "number"}`}
            className="form-control"
            placeholder={field.field_name}
            name={field.field_name}
            value={inputValue}
            min="0"
            onChange={(e) =>
              handleInputChange(
                fields,
                IsNumber(e.target.value)
                  ? Number(e.target.value)
                  : e.target.value,
                props
              )
            }
          />
        );
      case "DATETIME":
      case "DATE":
        return (
          <>
            <section className="d-flex date">
              <div className="input-search col-md-4 pl-0 d-flex align-items-center">
                <label htmlFor={field.field_name} style={{ width: "25%" }}>
                  {lang["log.daystart"]}:
                </label>
                <span style={{ width: "70%" }}>
                  <input
                    key={refreshSearch}
                    type="date"
                    className="form-control"
                    placeholder={field.field_name}
                    name={field.field_name}
                    // value={inputValue.from}
                    onChange={({ target: { value } }) => {
                      let payload = { from: value, to: inputValue?.to };

                      handleInputChange(fields, payload, props);
                    }}
                  />
                </span>
              </div>
              <div className="input-search col-md-4 pl-0 d-flex align-items-center">
                <label htmlFor={field.field_name} style={{ width: "25%" }}>
                  {lang["log.dayend"]}:
                </label>
                <span style={{ width: "70%" }}>
                  <input
                    key={refreshSearch}
                    type="date"
                    className="form-control"
                    placeholder={field.field_name}
                    name={field.field_name}
                    // value={inputValue.to}
                    onChange={({ target: { value } }) => {
                      let payload = { from: inputValue?.from, to: value };

                      handleInputChange(fields, payload, props);
                    }}
                  />
                </span>
              </div>
            </section>
          </>
        );
      // case "DATETIME":
      //   return (
      //     <input
      //       type="datetime-local"
      //       className="form-control"
      //       placeholder={field.field_name}
      //       value={inputValue}
      //       onChange={(e) =>
      //         handleInputChange(field.fomular_alias, e.target.value)
      //       }
      //     />
      //   );
      case "BOOL":
        return (
          <select
            // value={inputValue === true ? "true" : "false"}
            onChange={(e) => handleInputChange(fields, e.target.value, props)}
            className="form-control"
          >
            <option value="" disabled>
              Choose
            </option>
            {valueBool.map((val, index) => (
              <option key={index} value={val.value.toString()}>
                {val.label}
              </option>
            ))}
          </select>
        );
      default:
        return (
          <input
            key={refreshSearch}
            type="text"
            // value={inputValue}
            className="form-control"
            onChange={(e) => handleInputChange(fields, e.target.value, props)}
          />
        );
    }
  };

  return (
    <div className="position-relative">
      <div className="d-flex justify-content-between align-items-center">
        <h5
          style={{
            color: "#44a1a1",
            fontSize: "18px",
            padding: "6px 0px",
          }}
        >
          {props.content}
        </h5>
        <div>
          <button
            className={`${
              !isCollapse ? "btn btn-secondary" : "btn btn-danger"
            }  m-0`}
            onClick={handleCollapse}
          >
            {!isCollapse ? (
              <>
                <FontAwesomeIcon icon={faSearch} /> {lang["search"]}
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faXmark} /> {lang["btn.close"]}
              </>
            )}
          </button>
        </div>
      </div>

      <div
        className={`content ${isCollapse ? "d-block" : "d-none"}`}
        style={{ background: "#dbdbdb" }}
      >
        <div className="row block-statis search position-relative d-flex flex-wrap">
          {data.map(
            (
              {
                fields,
                label,
                isMulti,
                search_type,
                reference_field,
                dateType,
              },
              i
            ) => {
              const { field, key } = fields[0].field;

              const isDateField =
                field?.DATATYPE === "DATETIME" || field?.DATATYPE === "DATE";
              const colClass =
                dateType.label === "Month" || dateType.label === "Year"
                  ? "col-md-12 p-0 mb-2"
                  : isDateField
                  ? "col-md-12 mb-2"
                  : "col-md-4 pl-0 mb-4";

              return (
                <div
                  key={i}
                  className={`${colClass}`}
                  // style={{
                  //   width: "25%",
                  // }}
                >
                  {isDateField ? (
                    <fieldset className="mb-3 ">
                      <label className="font-weight-bold">{label}</label>
                      {renderInput(
                        field,
                        { isMulti, reference_field, fields, search_type },
                        dateType?.value,
                        key
                      )}
                    </fieldset>
                  ) : (
                    <div className="d-flex flex-wrap">
                      <label
                        className="font-weight-bold m-0"
                        htmlFor={label}
                        style={{ width: "25%" }}
                      >
                        {label}
                      </label>
                      <span style={{ width: "70%" }}>
                        {renderInput(
                          field,
                          { isMulti, reference_field, fields, search_type },
                          dateType?.value,
                          key
                        )}
                      </span>
                    </div>
                  )}
                </div>
              );
            }
          )}
        </div>
        <div className="" style={{ right: "-11px", textAlign: "right" }}>
          <button
            onClick={handleResetSearchValue}
            className="btn btn-secondary mr-3 mb-2"
          >
            <i class="fa fa-history mr-1 icon-search" />
            {lang["Refresh"]}
          </button>
          <button onClick={handleSubmit} className="btn btn-primary mr-3 mb-2">
            <i class="fa fa-search mr-1 icon-search" />
            {lang["search"]}
          </button>
          {extraButtons?.props?.buttons?.export.state === true && (
            <div className="btn btn-light mr-3 style-btn">
              {extraButtons} {lang["export"]}{" "}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const ConvertToDate = (key, value, keys = []) => {
  if (keys.includes(key)) {
    return new Date(value).toLocaleString();
  }
  return value;
};

const RenderDetail = (props) => {
  console.log("730", props.props);
  const { isParam, buttonId } = props;
  const PROPS = props;
  const { url } = useParams();
  const urls = window.location;
  const rawParams = urls.pathname.split(`/${url}/`)[1];
  const { lang, proxy, auth, functions, pages } = useSelector((state) => state);
  const _token = localStorage.getItem("_token");
  const [apiDataDetail, setApiDataDetail] = useState({});
  const [isFetching, setIsFetching] = useState(false);
  const [showImage, setShowImage] = useState(true);

  useEffect(() => {
    callApiDetail(props.props.api.url);
  }, [isParam]);

  const callApiDetail = async (url) => {
    setIsFetching(true);
    const start_time = new Date().getTime();

    let params = window.location.pathname
      .slice(1)
      .replace(props.page.page_id, "");

    if (!props.page?.old_url_format) {
      params += "/";
      window.location.search
        .slice(1)
        .split("&")
        .map((item) => {
          const [key, value] = item.split("=");
          if (value) {
            params += value;
          } else {
            params += isParam;
          }
        });
    }

    const mapped_data = {};
    const btnId = sessionStorage.getItem("buttonId");
    try {
      const res = await fetch(
        `${proxy()}${url}${params}/?cpn_id=${
          PROPS.page.component[0].id
        }&buttonId=${buttonId || btnId}&isPublic=${
          props?.page?.is_public
        }&page=${window.location.pathname}`,
        {
          headers: {
            Authorization: _token,
          },
        }
      );

      const { success, data } = await res.json();

      if (success) {
        if (data !== undefined) {
          for (const k in data) {
            if (k !== "_id" && data[k] !== null) {
              mapped_data[k] = data[k];
            }
          }
        }
      }
    } catch (e) {
      console.log("ERROR FETCH DETAIL", e);
    }
    props?.onRendering(Object.values(mapped_data).length !== 0);
    setApiDataDetail(mapped_data);
    DelayLoading(start_time, () => setIsFetching(false));
  };

  function MappingValue(value, format) {
    if (IsDate(value)) {
      value = moment.utc(value).format(format ? format : "DD/MM/YYYY");
    }
    return value;
  }

  const renderLabel = (child) => {
    const propsLabel = child?.props;
    const fieldShow = child?.props?.field;

    switch (child?.childName || child?.name || child?.label) {
      case "text":
        return (
          <label style={{ ...propsLabel.style }}>{propsLabel.content}</label>
        );
      case "detail_text":
        return (
          <div
            className="detail_text d-flex align-items-center"
            style={{ ...propsLabel.styles }}
          >
            {icons[propsLabel.icon]?.icon ? (
              <span style={{ ...propsLabel.styleIcon }}>
                <FontAwesomeIcon icon={icons[propsLabel.icon]?.icon} />
              </span>
            ) : null}
            <span style={{ ...propsLabel.stylePrefix }}>
              {propsLabel.prefix}
            </span>

            <span
              className="data"
              style={{ ...propsLabel.style }}
              dangerouslySetInnerHTML={{
                __html: MappingValue(
                  apiDataDetail[fieldShow.label],
                  propsLabel?.dateFormat
                ),
              }}
            />
            <span style={{ ...propsLabel.stylePostfix }}>
              {propsLabel.postfix}
            </span>
          </div>
        );
      case "detail_image":
        const styleImage = { ...propsLabel.style };
        const baseUrl = proxy();
        if (
          Array.isArray(apiDataDetail[fieldShow.value]) &&
          apiDataDetail[fieldShow.value].length > 0
        ) {
          if (apiDataDetail[fieldShow.value].length > 1) {
            return functions.renderFiles(
              apiDataDetail[fieldShow.value],
              baseUrl,
              setShowImage
            );
            // <div>
            //   {showImage ? (
            //     <div
            //       id="carouselExampleIndicators"
            //       class="carousel slide"
            //       data-ride="carousel"
            //       data-interval="1000"
            //     >
            //       <div class="carousel-inner">

            //       </div>
            //       <a
            //         class="carousel-control-prev"
            //         href="#carouselExampleIndicators"
            //         role="button"
            //         data-slide="prev"
            //       >
            //         <span
            //           class="carousel-control-prev-icon"
            //           aria-hidden="true"
            //         ></span>
            //         <FontAwesomeIcon
            //           icon={faChevronLeft}
            //           color="black"
            //           fontSize="25px"
            //         />
            //       </a>
            //       <a
            //         class="carousel-control-next"
            //         href="#carouselExampleIndicators"
            //         role="button"
            //         data-slide="next"
            //       >
            //         <span
            //           class="carousel-control-next-icon"
            //           aria-hidden="true"
            //         ></span>
            //         <FontAwesomeIcon
            //           icon={faChevronRight}
            //           color="black"
            //           fontSize="25px"
            //         />
            //       </a>
            //     </div>
            //   ) : (
            //     <img
            //       alt="#"
            //       src="/images/icon/file-unknown.svg"
            //       className="view-image-detail unknown"
            //       style={{
            //         width: styleImage?.width ? styleImage?.width : "100%",
            //         height: styleImage?.height ? styleImage?.height : "400px",
            //         objectFit: "contain",
            //       }}
            //     />
            //   )}
            // </div>
          } else {
            return (
              <>
                {functions.renderFiles(
                  apiDataDetail[fieldShow.value],
                  baseUrl,
                  setShowImage,
                  styleImage,
                  isParam
                )}
              </>
            );
          }
          return null;
        } else {
          return (
            <>
              <img
                alt="#"
                src="/images/icon/file-unknown.svg"
                className="view-image-detail unknown"
                style={{ ...propsLabel.style, height: "100px" }}
                loading="lazy"
              />
            </>
          );
        }
      case "grid":
        return child?.props?.style?.grid?.map((data, index) => {
          return (
            <div className={`col-sm-${data.value}`}>
              {data?.child?.map((dc) => {
                const findId = child?.children.find((cs) => cs.id === dc.id);
                if (findId) {
                  return renderLabel(findId);
                }
              })}
            </div>
          );
        });

      default:
        return 0;
    }
  };
  if (isFetching) {
    return (
      <img
        width={40}
        className="loading-image"
        src="/images/icon/load.gif"
        alt="Loading..."
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}
      />
    );
  }
  return (
    <>
      {Object.values(apiDataDetail).length > 0 ? (
        <div style={props.style}>
          <div class="d-flex align-items-center mt-2">
            <div class="col-md-12">
              {props.cpn.children.map((child, index) => {
                return (
                  <div
                    className={child.name === "grid" ? "row" : ""}
                    key={index}
                  >
                    {renderLabel(child)}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
export default RenderComponent;
